export { a as AnalyticsHelpers } from './analytics-helpers-a196cc05.js';
export { m as MoFormHelper } from './mo-form-helpers-39466077.js';
export { m as MoLayoutHelper } from './mo-layout-helpers-cab48bb9.js';
import { g as getStoreApiService, i as invokeService, d as dist, s as setStoreApiServiceConfig, A as ApiService } from './zone-component-utils-5b66a38f.js';
export { A as ApiService, e as QueryServiceStore, Q as QueryStore, R as RenderStore, r as RenderStoreMockHelpers, c as TemplatingStoreHelpers, z as ZoneComponentUtils, Z as ZoneStore, f as agentSearchData, b as buildIntrospectApi, g as getStoreApiService, i as invokeStoreService, m as makeFetchRequest, a as setStoreApiService, s as setStoreApiServiceConfig } from './zone-component-utils-5b66a38f.js';
export { M as MoDatesService } from './date-service-e05d3c96.js';
import { l as lodash, c as createCommonjsModule } from './lodash-5c867657.js';
import { F as Ft, D as DataStoreMockPlugin } from './DataStoreMockPlugin-243a33f9.js';
export { D as DataStoreMockPlugin } from './DataStoreMockPlugin-243a33f9.js';
import { M as MoBaseStore } from './MoBaseStore-6200f34f.js';
export { M as MoBaseStore, a as MoModel } from './MoBaseStore-6200f34f.js';
export { M as MoStore } from './MoStore-fb0c683e.js';
import './index-9b297a6c.js';
export { c as ComponentUtils } from './component-utils-5da0c39f.js';
export { d as DateUtils, f as FacetUtils } from './facet-utils-e3d7ec80.js';
export { d as DomUtils } from './dom-utils-303a0957.js';
import { g as getBaseUrl, s as setInnumerableProp } from './mo-utils-eb97378b.js';
export { m as MoUtils } from './mo-utils-eb97378b.js';
export { t as ThemingUtils } from './theming-utils-c0136da3.js';
export { g as getAppErrorDetails } from './mo-app-error-helpers-87ed6bb7.js';
import { g as getSortOptions, a as getSortFieldMap, b as getSortOrderMap } from './sort-helper-9d77b6e1.js';
import { C as ComponentAction } from './ComponentActionEvent-6f4ff80e.js';
export { t as TypeaheadUtils } from './typeahead-utils-46da65ec.js';
export { r as ResultUtils } from './result-utils-9fbefa9b.js';
export { m as MoSaasWizardHelper } from './mo-saas-wizard.helper-ba268d7e.js';
import './smoothscroll-9c638e2b.js';
export { a as MoFusionDataModelsHelpers, m as MoObjectEditorHelpers } from './mo-fusion-data-models-helpers-10faaf82.js';
export { m as MoGeoMapHelper, g as googleMapService } from './google-map-service-2239289e.js';
export { d as D3Utils } from './d3-utils-f8d9837f.js';
export { m as MoDocsListHelper } from './mo-docs-list-helpers-89807e45.js';
import './ajv-5cae5b23.js';
import './muuri.module-ee0c2f7a.js';
export { r as RulesUtils } from './rules-utils-96d4f45c.js';
import './v4-551b60de.js';
import './index-78f24412.js';
import './index-7eb9c37a.js';

class EventService {
    static getEventBus() {
        let notifyInfo = {};
        return {
            on,
            un,
            fireEvent,
            unregisterAll
        };
        /**
         * @param {String|Object} event - Could be string type with multiple events divided by comma.
         *                                For example, 'foo' or 'foo, bar, ...'
         *                                Or a key value pairs map of event name to handler.
         *                                For example: { foo: handlerFoo, bar: handlerBar, ... }
         * @param {Function} [handler] - Handler for string type event.
         * @return {Function} - Function to unsubscribe from registered events.
         */
        function on(event, handler) {
            let events;
            let unSubscribeFuns;
            if (lodash.isString(event)) {
                events = event.split(',').map(lodash.trim);
            }
            else {
                events = lodash.map(event, (subHandler, subEvent) => ({ subEvent, subHandler }));
            }
            unSubscribeFuns = lodash.map(events, (info) => doOn(info.subEvent || info, info.subHandler || handler));
            if (unSubscribeFuns.length > 0) {
                return lodash.flow(...unSubscribeFuns);
            }
        }
        /**
         * @private
         */
        function doOn(event, handler) {
            const handlerList = notifyInfo[event] || (notifyInfo[event] = []);
            let unSubscribeFun = lodash.noop;
            if (lodash.isFunction(handler)) {
                handlerList.push(handler);
                unSubscribeFun = () => un(event, handler);
            }
            return unSubscribeFun;
        }
        function fireEvent(event, ...args) {
            const handlerList = notifyInfo[event] || [];
            if (handlerList.length > 0) {
                lodash.each(handlerList, (handler) => handler(...args));
            }
        }
        function un(event, handler) {
            if (handler) {
                lodash.pull(notifyInfo[event], handler);
            }
            else {
                delete notifyInfo[event];
            }
        }
        function unregisterAll() {
            notifyInfo = {};
        }
    }
    /**
     * Extend the object to be eventable via the internal event bus.
     */
    static makeEventable(object) {
        if (!object._eventBus) {
            const eventBus = EventService.getEventBus();
            object._eventBus = eventBus;
            lodash.defaults(object, eventBus);
        }
    }
}

class FeatureFlagService {
    constructor() {
        this._featureFlags = {};
        this.init = async (envId, ldUser, FEATURE_FLAGS) => {
            if (!envId || !ldUser) {
                throw new Error('Error initializing feature flag service');
            }
            const context = {
                kind: 'user',
                key: ldUser.email,
                customer_id: ldUser.customerId,
                application_id: ldUser.appId,
            };
            this._ldClient = Ft(envId, context);
            await new Promise(resolve => {
                this._ldClient.on('ready', () => {
                    Object.values(FEATURE_FLAGS).forEach(flagName => {
                        this._featureFlags[flagName] = this._ldClient.variation(flagName, false);
                    });
                    resolve();
                });
            });
        };
        this.getFlag = (flag) => {
            if (lodash.isEmpty(this._featureFlags)) {
                throw new Error('FeatureFlagService was not properly initialized.  You must "await init()" before calling "getFlag()"');
            }
            return this._featureFlags[flag] || false;
        };
    }
}
const featureFlagService = new FeatureFlagService();

class MoDataStore extends MoBaseStore {
    constructor(config) {
        var _a, _b;
        var _c;
        super([], config);
        this.loaded = false;
        this.loading = false;
        this.alwaysRefreshData = false;
        this.defaultParamsList = ['service', 'idProp'];
        this.loadCounter = 0;
        const defaultConfig = lodash.get(this.constructor, 'defaultConfig', {});
        this.config = lodash(config).defaults(defaultConfig).cloneDeep();
        (_a = (_c = this.config).mock) !== null && _a !== void 0 ? _a : (_c.mock = (_b = getStoreApiService()) === null || _b === void 0 ? void 0 : _b.meta.config.mock);
        if (!this.config.mock) {
            this.onChanges = lodash.compact([lodash.get(this.config, 'onChange')]);
            this.apiConfig = this.config.api;
            this.processConfig();
            this.processCustomProperties();
            lodash.assign(this, this.config.customProperties);
        }
        EventService.makeEventable(this);
    }
    /**
     * == Public methods =============================================================================
     */
    /**
     * The `meta` getter is hooked up with it in the super class, which provides the read-only info via store.meta.
     */
    getMeta() {
        const propList = ['config', 'data', 'loaded', 'alwaysRefreshData', 'idProp'];
        return Object.assign({}, this.cloneProps(propList));
    }
    subscribe(callback, component) {
        const unSubscribe = super.subscribe(callback, component);
        this.initialize();
        return unSubscribe;
    }
    setApiConfig({ method = null, prop, value }) {
        const path = lodash.compact([method, prop]).join('.');
        lodash.set(this.apiConfig, path, value);
    }
    /**
     * Apply plugins and do initial load.
     */
    initialize(initLoad = true) {
        const { mock, mockPlugin } = this.config;
        if (mock && mockPlugin && !this.appliedMockPlugin) {
            this.appliedMockPlugin = new mockPlugin(this);
            this.appliedMockPlugin.applyMocks();
        }
        if (initLoad && !this.loaded && !this.loading) {
            this.load();
        }
        return this;
    }
    /**
     * Set data and notify subscribers.
     */
    setData(data, changeMeta) {
        this.data = data;
        this.loaded = true;
        this.notifyUpdates(changeMeta);
        this.fireEvent(changeMeta.action);
    }
    load(options = {}, action = 'load') {
        const loadConfig = this.getDefaultLoadingConfig();
        const loadParams = this.getLoadingParams();
        const counter = this.loadCounter + 1;
        this.loading = true;
        this.loadCounter = counter;
        return this.requestList(loadConfig, options, loadParams).then((response) => {
            // REVIEW: Only handle the latest loading request to keep things simple. will do the full
            // fetch abort handling when necessary.
            if (counter === this.loadCounter) {
                const result = this.transformData(response, loadConfig, options);
                this.loading = false;
                this.setData(result, { action });
            }
            return response;
        });
    }
    /**
     * Get item details data by item id.
     *
     * @param itemId - Item id.
     * @param options - Options which will be applied to template string like placeholder in header, pathParams, and queryParams
     */
    getItem(itemId, options) {
        const config = this.applyDefaultConfig(this.apiConfig.get);
        const idProp = this.idProp;
        const params = { pathParams: { [config.idProp]: itemId } };
        return invokeService(config, options, params).then((itemData) => {
            this.transformData(itemData, config, options);
            if (this.apiConfig.includeItemDetailsInList && this.loaded) {
                const index = lodash.findIndex(this.data, { [idProp]: itemData[idProp] });
                this.data[index] = lodash.cloneDeep(itemData);
            }
            this.notifyUpdates({ action: 'getItemDetails', item: itemData });
            return itemData;
        });
    }
    /**
     * Add item to the list with passed data.
     *
     * @param data - Item data.
     * @param options - Options which will be applied to template string like placeholder in header, pathParams, and queryParams
     */
    addItem(data, options) {
        const config = this.applyDefaultConfig(this.apiConfig.add);
        const idProp = this.idProp;
        let params;
        params = {
            pathParams: { [config.idProp]: data[idProp] },
            data: this.transformData(data, config, options)
        };
        return invokeService(config, options, params).then((itemData) => {
            if (!lodash.isObject(itemData) || lodash.isEmpty(itemData)) {
                itemData = lodash.defaults(data, { [idProp]: data[idProp] });
            }
            if (this.loaded) {
                this.syncList(config, itemData, () => {
                    this.data.push(itemData);
                });
            }
            this.notifyUpdates({ action: 'add', item: itemData });
            this.fireEvent('add', itemData);
            return itemData;
        });
    }
    /**
     * Update item to the list with passed data.
     *
     * @param data - Item data.
     * @param options - Options which will be applied to template string like placeholder in header, pathParams, and queryParams
     */
    updateItem(data, options) {
        const config = this.applyDefaultConfig(this.apiConfig.update);
        const idProp = this.idProp;
        const params = {
            pathParams: { [config.idProp]: data[idProp] },
            data: this.transformData(data, config, options)
        };
        return invokeService(config, options, params).then(() => {
            if (this.loaded && this.apiConfig.includeItemDetailsInList) {
                this.syncList(config, data, () => {
                    const index = lodash.findIndex(this.data, { [idProp]: data[idProp] });
                    this.data[index] = lodash.cloneDeep(data);
                    this.notifyUpdates({ action: 'update', item: data });
                    this.fireEvent('update', data);
                });
            }
            else if (this.alwaysRefreshData) {
                this.load({}, 'refresh');
            }
            return data;
        });
    }
    /**
     * Remove item from the list with passed id or data.
     *
     * @param info - Item id or data.
     * @param options - Options which will be applied to template string like placeholder in header, pathParams, and queryParams
     */
    removeItem(info, options) {
        const config = this.applyDefaultConfig(this.apiConfig.remove);
        const idProp = this.idProp;
        const itemData = lodash.isString(info) ? { [idProp]: info } : info;
        const itemId = itemData[idProp];
        const params = { pathParams: { [config.idProp]: itemId } };
        return invokeService(config, options, params).then(() => {
            if (this.loaded) {
                this.syncList(config, itemData, () => {
                    lodash.remove(this.data, { [idProp]: itemId });
                });
                this.notifyUpdates({ action: 'remove', item: itemData });
                this.fireEvent('remove', itemData);
            }
        });
    }
    /**
     * Route to `addItem` or `updateItem` for persisting either new item or existing item.
     */
    saveItem(data, options, isNewItem = false) {
        const newItem = isNewItem || lodash.isEmpty(data[this.idProp]);
        return lodash.invoke(this, newItem ? 'addItem' : 'updateItem', data, options);
    }
    clear(reload = true) {
        if (this.loaded) {
            this.loaded = false;
            if (reload) {
                this.load();
                this.fireEvent('clear');
            }
        }
    }
    /**
     * == Protected and private methods =============================================================================
     */
    notifyUpdatesOnSubscribe(callback) {
        if (this.loaded) {
            super.notifyUpdatesOnSubscribe(callback);
        }
    }
    getLoadConfig() {
        return this.apiConfig.list;
    }
    getDefaultLoadingConfig() {
        return this.applyDefaultConfig(this.getLoadConfig());
    }
    processConfig() {
        const actions = 'list, search, get, add, update, remove'.split(', ');
        const apiConfig = this.apiConfig;
        apiConfig.idProp = apiConfig.idProp || this.idProp;
        lodash.each(actions, (action) => {
            const config = apiConfig[action];
            apiConfig[action] = lodash.isString(config) ? { name: config } : config;
            lodash.defaults(apiConfig[action], lodash.pick(apiConfig, this.defaultParamsList), { storeContext: this });
        });
        if (this.config.loadDebounceDelay) {
            this.load = dist(this.load, this.config.loadDebounceDelay);
        }
        if (this.config.apiMeta) {
            setStoreApiServiceConfig({ apiMeta: this.config.apiMeta });
        }
    }
    callApiMethod(config, options, defaultParams) {
        const apiConfig = this.applyDefaultConfig(config);
        lodash.defaults(apiConfig, { service: this.apiConfig.service });
        return invokeService(apiConfig, options, defaultParams).then((result) => {
            if (config.refreshAfter) {
                this.load({}, 'refresh');
            }
            return result;
        });
    }
    /**
     * Extra request params for loading list in subclasses.
     */
    getLoadingParams() {
        return {};
    }
    async getMockData() {
        return [];
    }
    requestList(config = this.getLoadConfig(), options = {}, defaultParams) {
        return invokeService(config, options, defaultParams);
    }
    syncList(methodConfig, data, defaultSync) {
        const synchMethod = methodConfig.synchronizer;
        if (this.alwaysRefreshData) {
            this.load();
        }
        else if (lodash.isFunction(synchMethod)) {
            synchMethod(this.data, data, defaultSync);
        }
        else {
            defaultSync();
        }
    }
    /**
     * If the custom property entry is API config object, convert it into a wrapper function which invokes API service.
     * Which are similar to get/add/update/remove cases.
     * @private
     */
    processCustomProperties() {
        const customProperties = this.config.customProperties || {};
        lodash.each(customProperties, (customConfig, key) => {
            if (!lodash.isFunction(customConfig) && customConfig) {
                customConfig = lodash.isString(customConfig) ? { name: customConfig } : customConfig;
                customConfig.service = customConfig.service || lodash.get(this.config, 'api.service');
                customProperties[key] = (options, defaultParams) => this.callApiMethod(customConfig, options, defaultParams);
            }
        });
    }
    applyDefaultConfig(config) {
        return lodash.each(config, (value, key) => {
            config[key] = (value === '_inherit_') ? this.apiConfig[key] : value;
        });
    }
    transformData(data, methodConfig, options) {
        const transforms = lodash([methodConfig.transform]).flatten().compact().value();
        let result = data;
        lodash.each(transforms, (transform) => {
            if (lodash.isFunction(transform)) {
                const tempResult = transform(result, options, this);
                if (!lodash.isArray(result)) {
                    result = tempResult;
                }
                else if (tempResult !== result) {
                    result.length = 0;
                    result.push(...tempResult);
                }
            }
        });
        return result;
    }
}

/**
 * Clone template function and assign CSF(Component Story Format) args accordingly.
 *
 * Please see https://storybook.js.org/docs/react/writing-stories/args for details of storybook args
 */
const getStory = (TemplateFunction, args) => {
    const story = TemplateFunction.bind({});
    story.args = args;
    return story;
};
/**
 * export default {
 *   argTypes: getEventActions(['onAdded', 'onSelected']),
 * };
 *
 * will be equivalent to
 *
 * export default {
 *   argTypes: {
 *     onAdded: { control: 'onAdded'},
 *     onSelected: { control: 'onSelected'},
 *   },
 * }
 */
const getEventActions = (eventNames) => lodash.keyBy(eventNames.map((action) => ({ action })), 'action');
/**
 * export default {
 *   argTypes: {
 *     inputType: getSelectControls(['filter', 'dropdown', 'none']),
 *   },
 * };
 *
 * will be equivalent to
 *
 * export default {
 *   argTypes: {
 *     inputType: {
 *       control: {
 *         type: 'select',
 *         options: ['filter', 'dropdown', 'none'],
 *       }
 *     }
 *   },
 * };
 *
 */
const getSelectControls = (options) => ({
    control: {
        type: 'select',
        options,
    }
});

const storybookUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getStory: getStory,
    getEventActions: getEventActions,
    getSelectControls: getSelectControls
});

const getCustomerIdFromUserInfo = userInfo => {
    if (userInfo.groups) {
        const customerGroup = userInfo.groups.find(group => {
            return group.match(/^customer\..*\..*/);
        });
        return customerGroup === null || customerGroup === void 0 ? void 0 : customerGroup.split('.')[1];
    }
};

const authUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getCustomerIdFromUserInfo: getCustomerIdFromUserInfo
});

const index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getSortOptions: getSortOptions,
    getSortFieldMap: getSortFieldMap,
    getSortOrderMap: getSortOrderMap
});

const index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get ComponentAction () { return ComponentAction; }
});

var dlv_umd = createCommonjsModule(function (module, exports) {
!function(t,n){module.exports=function(t,n,e,i,o){for(n=n.split?n.split("."):n,i=0;i<n.length;i++)t=t?t[n[i]]:o;return t===o?e:t};}();
//# sourceMappingURL=dlv.umd.js.map
});

"undefined"!=typeof process?process:{};var $$2="undefined"!=typeof document;"undefined"!=typeof Deno&&void 0!==Deno.core;$$2&&"nodejs"===window.name||"undefined"!=typeof navigator&&void 0!==navigator.userAgent&&(navigator.userAgent.includes("Node.js")||navigator.userAgent.includes("jsdom"));function M$2(n,t){return t.charAt(0)[n]()+t.slice(1)}var U$1=M$2.bind(null,"toUpperCase"),H$2=M$2.bind(null,"toLowerCase");function J$2(n){return Y$1(n)?U$1("null"):"object"==typeof n?yn$1(n):Object.prototype.toString.call(n).slice(8,-1)}function R$1(n,t){void 0===t&&(t=!0);var e=J$2(n);return t?H$2(e):e}function V$1(n,t){return typeof t===n}var W$1=V$1.bind(null,"function"),q$1=V$1.bind(null,"string");V$1.bind(null,"undefined");V$1.bind(null,"boolean");V$1.bind(null,"symbol");function Y$1(n){return null===n}function nn$1(n){return "number"===R$1(n)&&!isNaN(n)}function yn$1(n){return W$1(n.constructor)?n.constructor.name:null}function hn$1(n){return n instanceof Error||q$1(n.message)&&n.constructor&&nn$1(n.constructor.stackTraceLimit)}function On$1(n,t){if("object"!=typeof t||Y$1(t))return !1;if(t instanceof n)return !0;var e=R$1(new n(""));if(hn$1(t))for(;t;){if(R$1(t)===e)return !0;t=Object.getPrototypeOf(t);}return !1}On$1.bind(null,TypeError);On$1.bind(null,SyntaxError);function $n$1(n,t){var e=n instanceof Element||n instanceof HTMLDocument;return e&&t?Tn$1(n,t):e}function Tn$1(n,t){return void 0===t&&(t=""),n&&n.nodeName===t.toUpperCase()}function _n$1(n){var t=[].slice.call(arguments,1);return function(){return n.apply(void 0,[].slice.call(arguments).concat(t))}}_n$1($n$1,"form");_n$1($n$1,"button");_n$1($n$1,"input");_n$1($n$1,"select");

function n$1(e){try{return decodeURIComponent(e.replace(/\+/g," "))}catch(e){return null}}function o$2(){if($$2){var r=navigator,t=r.languages;return r.userLanguage||(t&&t.length?t[0]:r.language)}}function a$3(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch(e){}}function s(r){return function(e){for(var r,t=Object.create(null),o=/([^&=]+)=?([^&]*)/g;r=o.exec(e);){var a=n$1(r[1]),i=n$1(r[2]);if(a)if("[]"===a.substring(a.length-2)){var u=t[a=a.substring(0,a.length-2)]||(t[a]=[]);t[a]=Array.isArray(u)?u:[],t[a].push(i);}else t[a]=""===i||i;}for(var c in t){var l=c.split("[");l.length>1&&(m(t,l.map(function(e){return e.replace(/[?[\]\\ ]/g,"")}),t[c]),delete t[c]);}return t}(function(r){if(r){var t=r.match(/\?(.*)/);return t&&t[1]?t[1].split("#")[0]:""}return $$2&&window.location.search.substring(1)}(r))}function m(e,r,t){for(var n=r.length-1,o=0;o<n;++o){var a=r[o];if("__proto__"===a||"constructor"===a)break;a in e||(e[a]={}),e=e[a];}e[r[n]]=t;}function y(){for(var e="",r=0,t=4294967295*Math.random()|0;r++<36;){var n="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[r-1],o=15&t;e+="-"==n||"4"==n?n:("x"==n?o:3&o|8).toString(16),t=r%8==0?4294967295*Math.random()|0:t>>4;}return e}

var e="undefined",o$1="object",j="__";"undefined"!=typeof process?process:{};var $$1="undefined"!=typeof document;"undefined"!=typeof Deno&&void 0!==Deno.core;$$1&&"nodejs"===window.name||"undefined"!=typeof navigator&&void 0!==navigator.userAgent&&(navigator.userAgent.includes("Node.js")||navigator.userAgent.includes("jsdom"));function M$1(n,t){return t.charAt(0)[n]()+t.slice(1)}var U=M$1.bind(null,"toUpperCase"),H$1=M$1.bind(null,"toLowerCase");function J$1(n){return Y(n)?U("null"):"object"==typeof n?yn(n):Object.prototype.toString.call(n).slice(8,-1)}function R(n,t){void 0===t&&(t=!0);var e=J$1(n);return t?H$1(e):e}function V(n,t){return typeof t===n}var W=V.bind(null,"function"),q=V.bind(null,"string");V.bind(null,"undefined");V.bind(null,"boolean");V.bind(null,"symbol");function Y(n){return null===n}function nn(n){return "number"===R(n)&&!isNaN(n)}function yn(n){return W(n.constructor)?n.constructor.name:null}function hn(n){return n instanceof Error||q(n.message)&&n.constructor&&nn(n.constructor.stackTraceLimit)}function On(n,t){if("object"!=typeof t||Y(t))return !1;if(t instanceof n)return !0;var e=R(new n(""));if(hn(t))for(;t;){if(R(t)===e)return !0;t=Object.getPrototypeOf(t);}return !1}On.bind(null,TypeError);On.bind(null,SyntaxError);function $n(n,t){var e=n instanceof Element||n instanceof HTMLDocument;return e&&t?Tn(n,t):e}function Tn(n,t){return void 0===t&&(t=""),n&&n.nodeName===t.toUpperCase()}function _n(n){var t=[].slice.call(arguments,1);return function(){return n.apply(void 0,[].slice.call(arguments).concat(t))}}_n($n,"form");_n($n,"button");_n($n,"input");_n($n,"select");

var l$1="global",o=j+"global"+j,n=typeof self===o$1&&self.self===self&&self||typeof global===o$1&&global.global===global&&global||void 0;function a$2(t){return n[o][t]}function f$1(t,e){return n[o][t]=e}function i$2(t){delete n[o][t];}function u$1(t,e,r){var l;try{if(b$1(t)){var o=window[t];l=o[e].bind(o);}}catch(t){}return l||r}n[o]||(n[o]={});var c$1={};function b$1(t){if(typeof c$1[t]!==e)return c$1[t];try{var e$1=window[t];e$1.setItem(e,e),e$1.removeItem(e);}catch(e){return c$1[t]=!1}return c$1[t]=!0}

var f="any",l="*",p="__";"undefined"!=typeof process?process:{};var z="undefined"!=typeof window;"undefined"!=typeof Deno&&void 0!==Deno.core;z&&"nodejs"===window.name||"undefined"!=typeof navigator&&(navigator.userAgent.includes("Node.js")||navigator.userAgent.includes("jsdom"));function C$1(n,e){return typeof e===n}var _=C$1.bind(null,"function"),L$1=C$1.bind(null,"string"),$=C$1.bind(null,"undefined"),x$1=C$1.bind(null,"boolean");function G$1(n){return "[object Array]"===Object.prototype.toString.call(n)}function H(n){return n&&("object"==typeof n||null!==n)}function M(n){if(!H(n))return !1;for(var e=n;null!==Object.getPrototypeOf(e);)e=Object.getPrototypeOf(e);return Object.getPrototypeOf(n)===e}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var runtime = {exports: {}};

(function (module) {
var runtime = function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }

  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  define(Gp, iteratorSymbol, function () {
    return this;
  });
  define(Gp, "toString", function () {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined$1,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined$1;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },
    stop: function () {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function (record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
module.exports );

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));

var regenerator = runtime.exports;

var FUNC = 'function';
var UNDEF = 'undefined';
var REDUCER = 'reducer';
var base = '@@redux/';
var ACTION_INIT = base + 'INIT';
var ACTION_TEST = base + Math.random().toString(36);

var $$observable = /* #__PURE__ */function () {
  return (typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) === FUNC && Symbol.observable || '@@observable';
}();
/*
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


var msg = ' != ' + FUNC;
function createStore(reducer, preloadedState, enhancer) {
  if (_typeof(preloadedState) === FUNC && _typeof(enhancer) === UNDEF) {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (_typeof(enhancer) !== UNDEF) {
    if (_typeof(enhancer) !== FUNC) {
      throw new Error('enhancer' + msg);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (_typeof(reducer) !== FUNC) {
    throw new Error(REDUCER + msg);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /*
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    return currentState;
  }
  /*
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (_typeof(listener) !== FUNC) {
      throw new Error('Listener' + msg);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    /* // add default info to actions... 
    console.log('dispatch before', _action)
    const action = {
      ..._action,
      ...{
        action: {
          ..._action.action,
          ...{ customInfo: 'yoooo'} 
        }
      }
    }
    console.log('dispatch after', action)
    /** */
    if (!M(action)) {
      throw new Error('Act != obj');
    }

    if (_typeof(action.type) === UNDEF) {
      throw new Error('ActType ' + UNDEF);
    }

    if (isDispatching) {
      throw new Error('Dispatch in ' + REDUCER);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (_typeof(nextReducer) !== FUNC) {
      throw new Error('next ' + REDUCER + msg);
    }

    currentReducer = nextReducer;
    dispatch({
      type: ACTION_INIT
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var outerSubscribe = subscribe;
    return _defineProperty$1({
      /*
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (_typeof(observer) !== 'object') {
          throw new TypeError('Observer != obj');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, $$observable, function () {
      return this;
    });
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ACTION_INIT
  });
  return _defineProperty$1({
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, $$observable, observable);
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && actionType.toString() || '?';
  return 'action ' + actionName + REDUCER + ' ' + key + ' returns ' + UNDEF;
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ACTION_INIT
    });

    if (_typeof(initialState) === UNDEF || _typeof(reducer(undefined, {
      type: ACTION_TEST
    })) === UNDEF) {
      throw new Error(REDUCER + ' ' + key + ' ' + UNDEF);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (_typeof(reducers[key]) === FUNC) {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers);

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (_typeof(nextStateForKey) === UNDEF) {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];
      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, _toConsumableArray(chain))(store.dispatch);
      return _objectSpread2$1(_objectSpread2$1({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/**
 * Anonymous visitor Id localstorage key
 * @typedef {String} ANON_ID
 */

var ANON_ID = p + 'anon_id'; // __anon_id

/**
 * Visitor Id localstorage key
 * @typedef {String} USER_ID
 */

var USER_ID = p + 'user_id'; // __user_id

/**
 * Visitor traits localstorage key
 * @typedef {String} USER_TRAITS
 */

var USER_TRAITS = p + 'user_traits'; // __user_traits

var LIB_NAME = 'analytics';
var ID = 'userId';
var ANONID = 'anonymousId';
var ERROR_URL = 'https://lytics.dev/errors/';

var coreEvents = [
/**
 * `bootstrap` - Fires when analytics library starts up.
 * This is the first event fired. '.on/once' listeners are not allowed on bootstrap
 * Plugins can attach logic to this event
 */
'bootstrap',
/**
 * `params` - Fires when analytics parses URL parameters
 */
'params',
/**
 * `campaign` - Fires if params contain "utm" parameters
 */
'campaign',
/**
 * `initializeStart` - Fires before 'initialize', allows for plugins to cancel loading of other plugins
 */
'initializeStart',
/**
 * `initialize` - Fires when analytics loads plugins
 */
'initialize',
/**
 * `initializeEnd` - Fires after initialize, allows for plugins to run logic after initialization methods run
 */
'initializeEnd',
/**
 * `ready` - Fires when all analytic providers are fully loaded. This waits for 'initialize' and 'loaded' to return true
 */
'ready',
/**
 * `resetStart` - Fires if analytic.reset() is called.
 * Use this event to cancel reset based on a specific condition
 */
'resetStart',
/**
 * `reset` - Fires if analytic.reset() is called.
 * Use this event to run custom cleanup logic (if needed)
 */
'reset',
/**
 * `resetEnd` - Fires after analytic.reset() is called.
 * Use this event to run a callback after user data is reset
 */
'resetEnd',
/******************
 * Page Events
 ******************/

/**
 * `pageStart` - Fires before 'page' events fire.
 *  This allows for dynamic page view cancellation based on current state of user or options passed in.
 */
'pageStart',
/**
 * `page` - Core analytics hook for page views.
 *  If your plugin or integration tracks page views, this is the event to fire on.
 */
'page',
/**
 * `pageEnd` - Fires after all registered 'page' methods fire.
 */
'pageEnd',
/**
 * `pageAborted` - Fires if 'page' call is cancelled by a plugin
 */
'pageAborted',
/****************
 * Track Events
 ***************/

/**
 * `trackStart` - Called before the 'track' events fires.
 *  This allows for dynamic page view cancellation based on current state of user or options passed in.
 */
'trackStart',
/**
 * `track` - Core analytics hook for event tracking.
 *  If your plugin or integration tracks custom events, this is the event to fire on.
 */
'track',
/**
 * `trackEnd` - Fires after all registered 'track' events fire from plugins.
 */
'trackEnd',
/**
 * `trackAborted` - Fires if 'track' call is cancelled by a plugin
 */
'trackAborted',
/******************
 * Identify Events
 ******************/

/**
 * `identifyStart` - Called before the 'identify' events fires.
 * This allows for dynamic page view cancellation based on current state of user or options passed in.
 */
'identifyStart',
/**
 * `identify` - Core analytics hook for user identification.
 *  If your plugin or integration identifies users or user traits, this is the event to fire on.
 */
'identify',
/**
 * `identifyEnd` - Fires after all registered 'identify' events fire from plugins.
 */
'identifyEnd',
/**
 * `identifyAborted` - Fires if 'track' call is cancelled by a plugin
 */
'identifyAborted',
/**
 * `userIdChanged` - Fires when a user id is updated
 */
'userIdChanged',
/******************
 * Plugin Events
 ******************/

/**
 * `registerPlugins` - Fires when analytics is registering plugins
 */
'registerPlugins',
/**
 * `enablePlugin` - Fires when 'analytics.plugins.enable()' is called
 */
'enablePlugin',
/**
 * `disablePlugin` - Fires when 'analytics.plugins.disable()' is called
 */
'disablePlugin',
/*
 * `loadPlugin` - Fires when 'analytics.loadPlugin()' is called
 */
// 'loadPlugin',

/******************
 * Browser activity events
 ******************/

/**
 * `online` - Fires when browser network goes online.
 * This fires only when coming back online from an offline state.
 */
'online',
/**
 * `offline` - Fires when browser network goes offline.
 */
'offline',
/******************
 * Storage events
 ******************/

/**
 * `setItemStart` - Fires when analytics.storage.setItem is initialized.
 * This event gives plugins the ability to intercept keys & values and alter them before they are persisted.
 */
'setItemStart',
/**
 * `setItem` - Fires when analytics.storage.setItem is called.
 * This event gives plugins the ability to intercept keys & values and alter them before they are persisted.
 */
'setItem',
/**
 * `setItemEnd` - Fires when setItem storage is complete.
 */
'setItemEnd',
/**
 * `setItemAborted` - Fires when setItem storage is cancelled by a plugin.
 */
'setItemAborted',
/**
 * `removeItemStart` - Fires when analytics.storage.removeItem is initialized.
 * This event gives plugins the ability to intercept removeItem calls and abort / alter them.
 */
'removeItemStart',
/**
 * `removeItem` - Fires when analytics.storage.removeItem is called.
 * This event gives plugins the ability to intercept removeItem calls and abort / alter them.
 */
'removeItem',
/**
 * `removeItemEnd` - Fires when removeItem storage is complete.
 */
'removeItemEnd',
/**
 * `removeItemAborted` - Fires when removeItem storage is cancelled by a plugin.
 */
'removeItemAborted'];
/* Keys on a plugin that are not considered events */

var nonEvents = ['name', 'EVENTS', 'config', 'loaded'];
var pluginEvents = {
  registerPluginType: function registerPluginType(name) {
    return "registerPlugin:".concat(name);
  },
  pluginReadyType: function pluginReadyType(name) {
    return "ready:".concat(name);
  }
};
var EVENTS = coreEvents.reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, pluginEvents);
var EVENTS$1 = EVENTS;
function isReservedAction(type) {
  return coreEvents.includes(type);
}

var utmRegex = /^utm_/;
var propRegex = /^an_prop_/;
var traitRegex = /^an_trait_/; // Middleware runs during EVENTS.initialize

function initializeMiddleware(instance) {
  var setItem = instance.storage.setItem;
  return function (store) {
    return function (next) {
      return function (action) {
        /* Handle bootstrap event */
        if (action.type === EVENTS$1.bootstrap) {
          var params = action.params,
              user = action.user,
              persistedUser = action.persistedUser,
              initialUser = action.initialUser;
          var isKnownId = persistedUser.userId === user.userId;
          /* 1. Set anonymous ID */

          if (persistedUser.anonymousId !== user.anonymousId) {
            setItem(ANON_ID, user.anonymousId);
          }
          /* 2. Set userId */


          if (!isKnownId) {
            setItem(USER_ID, user.userId);
          }
          /* 3. Set traits if they are different */


          if (initialUser.traits) {
            setItem(USER_TRAITS, _objectSpread2$1(_objectSpread2$1({}, isKnownId && persistedUser.traits ? persistedUser.traits : {}), initialUser.traits));
            /* TODO multi user setup
            setItem(`${USER_TRAITS}.${user.userId}`, {
              ...(isKnownId) ? existingTraits : {},
              ...initialUser.traits
            })
            */
          }
          /* 4. Parse url params */


          var paramsArray = Object.keys(action.params);

          if (paramsArray.length) {
            var an_uid = params.an_uid,
                an_event = params.an_event;
            var groupedParams = paramsArray.reduce(function (acc, key) {
              // match utm params & dclid (display) & gclid (cpc)
              if (key.match(utmRegex) || key.match(/^(d|g)clid/)) {
                var cleanName = key.replace(utmRegex, '');
                var keyName = cleanName === 'campaign' ? 'name' : cleanName;
                acc.campaign[keyName] = params[key];
              }

              if (key.match(propRegex)) {
                acc.props[key.replace(propRegex, '')] = params[key];
              }

              if (key.match(traitRegex)) {
                acc.traits[key.replace(traitRegex, '')] = params[key];
              }

              return acc;
            }, {
              campaign: {},
              props: {},
              traits: {}
            });
            store.dispatch(_objectSpread2$1(_objectSpread2$1({
              type: EVENTS$1.params,
              raw: params
            }, groupedParams), an_uid ? {
              userId: an_uid
            } : {}));
            /* If userId set, call identify */

            if (an_uid) {
              // timeout to debounce and make sure integration is registered. Todo refactor
              setTimeout(function () {
                return instance.identify(an_uid, groupedParams.traits);
              }, 0);
            }
            /* If tracking event set, call track */


            if (an_event) {
              // timeout to debounce and make sure integration is registered. Todo refactor
              setTimeout(function () {
                return instance.track(an_event, groupedParams.props);
              }, 0);
            } // if url has utm params


            if (Object.keys(groupedParams.campaign).length) {
              store.dispatch({
                type: EVENTS$1.campaign,
                campaign: groupedParams.campaign
              });
            }
          }
        }

        return next(action);
      };
    };
  };
}

/* user reducer */

function userReducer(storage) {
  return function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type === EVENTS$1.setItemEnd) {
      // Set anonymousId if changed by storage.setItem
      if (action.key === ANON_ID) {
        return _objectSpread2$1(_objectSpread2$1({}, state), {
          anonymousId: action.value
        });
      } // Set userId if changed by storage.setItem


      if (action.key === USER_ID) {
        return _objectSpread2$1(_objectSpread2$1({}, state), {
          userId: action.value
        });
      }
    }

    switch (action.type) {
      case EVENTS$1.identify:
        return Object.assign({}, state, {
          userId: action.userId,
          traits: _objectSpread2$1(_objectSpread2$1({}, state.traits), action.traits)
        });

      case EVENTS$1.reset:
        // Side effect to fix race condition in Node. TODO refactor
        // This is from default storage.removeItem: (key) => globalContext[key] = undefined
        [USER_ID, ANON_ID, USER_TRAITS].forEach(function (key) {
          // sync storage, not instance.storage
          storage.removeItem(key);
        });
        return Object.assign({}, state, {
          userId: null,
          // TODO reset anon id automatically?
          anonymousId: null,
          traits: {}
        });

      default:
        return state;
    }
  };
}
function getPersistedUserData(storage) {
  return {
    userId: storage.getItem(USER_ID),
    anonymousId: storage.getItem(ANON_ID),
    traits: storage.getItem(USER_TRAITS)
  };
}
var tempKey = function tempKey(key) {
  return p + 'TEMP' + p + key;
};
function getUserPropFunc(storage) {
  return function getUserProp(key, instance, payload) {
    /* 1. Try current state */
    var currentId = instance.getState('user')[key];

    if (currentId) {
      /*
      console.log(`from state ${key}`, currentId)
      /** */
      return currentId;
    }
    /* 2. Try event payload */


    if (payload && M(payload) && payload[key]) {
      /*
      console.log(`from payload ${key}`, payload[key])
      /** */
      return payload[key];
    }
    /* 3. Try persisted data */


    var persistedInfo = getPersistedUserData(storage)[key];

    if (persistedInfo) {
      /*
      console.log(`from persistedInfo ${key}`, persistedInfo)
      /** */
      return persistedInfo;
    }
    /* 4. Else, try to get in memory placeholder. TODO watch this for future issues */


    return a$2(tempKey(key)) || null;
  };
}

function identifyMiddleware(instance) {
  var _instance$storage = instance.storage,
      setItem = _instance$storage.setItem,
      removeItem = _instance$storage.removeItem,
      getItem = _instance$storage.getItem;
  return function (store) {
    return function (next) {
      return function (action) {
        var userId = action.userId,
            traits = action.traits,
            options = action.options;
        /* Reset user id and traits */

        if (action.type === EVENTS$1.reset) {
          // Remove stored data
          [USER_ID, USER_TRAITS, ANON_ID].forEach(function (key) {
            // Fires async removeItem dispatch
            removeItem(key);
          });
          [ID, ANONID, 'traits'].forEach(function (key) {
            // Remove from global context
            i$2(tempKey(key));
          });
        }

        if (action.type === EVENTS$1.identify) {
          /* If no anon id. Set it! */
          if (!getItem(ANON_ID)) {
            setItem(ANON_ID, y());
          }

          var currentId = getItem(USER_ID);
          var currentTraits = getItem(USER_TRAITS) || {};

          if (currentId && currentId !== userId) {
            store.dispatch({
              type: EVENTS$1.userIdChanged,
              old: {
                userId: currentId,
                traits: currentTraits
              },
              "new": {
                userId: userId,
                traits: traits
              },
              options: options
            });
          }
          /* Save user id */


          if (userId) {
            setItem(USER_ID, userId);
          }
          /* Save user traits */


          if (traits) {
            setItem(USER_TRAITS, _objectSpread2$1(_objectSpread2$1({}, currentTraits), traits));
          }
        }

        return next(action);
      };
    };
  };
}

var stack = {};

function runCallback(id, payload) {
  if (stack[id] && _(stack[id])) {
    // console.log(`run ${id}`)
    stack[id](payload);
    delete stack[id];
  }
}

function waitForReady(data, predicate, timeout) {
  return new Promise(function (resolve, reject) {
    if (predicate()) {
      return resolve(data);
    } // Timeout. Add to queue


    if (timeout < 1) {
      return reject(_objectSpread2$1(_objectSpread2$1({}, data), {}, {
        queue: true
      })); // eslint-disable-line
    } // Else recursive retry


    return pause(10).then(function (_) {
      return waitForReady(data, predicate, timeout - 10).then(resolve, reject);
    });
  });
}

function pause(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function processQueue(store, getPlugins, instance) {
  var pluginMethods = getPlugins();

  var _store$getState = store.getState(),
      plugins = _store$getState.plugins,
      context = _store$getState.context,
      queue = _store$getState.queue,
      user = _store$getState.user;

  var isOnline = !context.offline;
  /* If network connection found and there is items in queue, process them all */

  if (isOnline && queue && queue.actions && queue.actions.length) {
    var pipeline = queue.actions.reduce(function (acc, item, index) {
      var isLoaded = plugins[item.plugin].loaded;

      if (isLoaded) {
        acc.process.push(item);
        acc.processIndex.push(index);
      } else {
        acc.requeue.push(item);
        acc.requeueIndex.push(index);
      }

      return acc;
    }, {
      processIndex: [],
      process: [],
      requeue: [],
      requeueIndex: []
    });

    if (pipeline.processIndex && pipeline.processIndex.length) {
      pipeline.processIndex.forEach(function (i) {
        var processAction = queue.actions[i]; // console.log('RePROCESS THIS>', processAction)
        // Call methods directly right now

        var currentPlugin = processAction.plugin;
        var currentMethod = processAction.payload.type;
        var method = pluginMethods[currentPlugin][currentMethod];

        if (method && _(method)) {
          /* enrich queued payload with userId / anon id if missing */

          /* TODO hoist enrich into where action queued? */
          // console.log('before', processAction.payload)
          var enrichedPayload = enrich(processAction.payload, user); // console.log('user.userId', user.userId)
          // console.log('user.anonymousId', user.anonymousId)
          // console.log('after enrich', enrichedPayload)

          method({
            payload: enrichedPayload,
            config: plugins[currentPlugin].config,
            instance: instance
          });
          /* Then redispatch for .on listeners / other middleware */

          var pluginEvent = "".concat(currentMethod, ":").concat(currentPlugin);
          store.dispatch(_objectSpread2$1(_objectSpread2$1({}, enrichedPayload), {}, {
            type: pluginEvent,

            /* Internal data for analytics engine */
            _: {
              called: pluginEvent,
              from: 'queueDrain'
            }
          }));
        }
      });
      /* Removed processed actions */

      var reQueueActions = queue.actions.filter(function (value, index) {
        // note !~ === return pipeline.processIndex.indexOf(index) === -1
        return !~pipeline.processIndex.indexOf(index);
      });
      /* Set queue actions. TODO refactor to non mutatable or move out of redux */

      queue.actions = reQueueActions;
    }
  }
}
/* Heartbeat retries queued events */

function heartBeat(store, getPlugins, instance) {
  // 3e3 === 3000 ms
  return setInterval(function () {
    return processQueue(store, getPlugins, instance);
  }, 3e3);
} // Assign userId && anonymousId values if present in payload but null

function enrich() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [ID, ANONID].reduce(function (acc, key) {
    if (payload.hasOwnProperty(key) && user[key] && user[key] !== payload[key]) {
      // console.log(`${key} stale update with ${user[key]}`)
      acc[key] = user[key];
    }

    return acc;
  }, payload);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function fitlerDisabledPlugins(allPlugins) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object.keys(allPlugins).filter(function (name) {
    var fromCallOptions = options.plugins || {}; // If enabled/disabled by options. Override settings

    if (x$1(fromCallOptions[name])) {
      return fromCallOptions[name];
    } // If all: false disable everything unless true explicitly set


    if (fromCallOptions.all === false) {
      return false;
    } // else use state.plugin settings


    if (settings[name] && settings[name].enabled === false) {
      return false;
    }

    return true;
  }).map(function (name) {
    return allPlugins[name];
  });
}

var endsWithStartRegex = /Start$/;
var bootstrapRegex = /^bootstrap/;
var readyRegex = /^ready/;
function runPlugins (_x, _x2, _x3, _x4, _x5) {
  return _ref.apply(this, arguments);
}
/**
 * Async reduce over matched plugin methods
 * Fires plugin functions
 */

function _ref() {
  _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(action, getPlugins, instance, store, eventsInfo) {
    var pluginObject, originalType, updatedType, state, activePlugins, allActivePluginKeys, allMatches, actionBefore, actionDuring, afterName, actionAfter;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pluginObject = _(getPlugins) ? getPlugins() : getPlugins;
            originalType = action.type;
            updatedType = originalType.replace(endsWithStartRegex, '');
            /* If action already dispatched exit early. This makes it so plugin methods are not fired twice. */

            if (!(action._ && action._.called)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", action);

          case 5:
            state = instance.getState();
            /* Remove plugins that are disabled by options or by settings */

            activePlugins = fitlerDisabledPlugins(pluginObject, state.plugins, action.options);
            /* If analytics.plugin.enable calls do special behavior */

            if (originalType === EVENTS$1.initializeStart && action.fromEnable) {
              // Return list of all enabled plugins that have NOT been initialized yet
              activePlugins = Object.keys(state.plugins).filter(function (name) {
                var info = state.plugins[name];
                return action.plugins.includes(name) && !info.initialized;
              }).map(function (name) {
                return pluginObject[name];
              });
            } // console.log(`engine activePlugins ${action.type}`, activePlugins)


            allActivePluginKeys = activePlugins.map(function (p) {
              return p.name;
            }); // console.log('allActivePluginKeys', allActivePluginKeys)

            allMatches = getAllMatchingCalls(originalType, activePlugins); // console.log('allMatches', allMatches)

            /* @TODO cache matches and purge on enable/disable/add plugin */

            /**
             * Process all 'actionBefore' hooks
             * Example:
             *  This is processes 'pageStart' methods from plugins and update the event to send through the chain
             */

            _context.next = 12;
            return processEvent({
              action: action,
              data: {
                exact: allMatches.before,
                namespaced: allMatches.beforeNS
              },
              state: state,
              allPlugins: pluginObject,
              allMatches: allMatches,
              instance: instance,
              store: store,
              EVENTS: eventsInfo
            });

          case 12:
            actionBefore = _context.sent;

            if (!shouldAbortAll(actionBefore, allActivePluginKeys.length)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", actionBefore);

          case 15:
            if (!(originalType === updatedType)) {
              _context.next = 19;
              break;
            }

            /* If type the same don't double process */
            actionDuring = actionBefore;
            _context.next = 22;
            break;

          case 19:
            _context.next = 21;
            return processEvent({
              action: _objectSpread2$1(_objectSpread2$1({}, actionBefore), {}, {
                type: updatedType
              }),
              data: {
                exact: allMatches.during,
                namespaced: allMatches.duringNS
              },
              state: state,
              allPlugins: pluginObject,
              allMatches: allMatches,
              instance: instance,
              store: store,
              EVENTS: eventsInfo
            });

          case 21:
            actionDuring = _context.sent;

          case 22:
            if (!originalType.match(endsWithStartRegex)) {
              _context.next = 28;
              break;
            }

            afterName = "".concat(updatedType, "End");
            _context.next = 26;
            return processEvent({
              action: _objectSpread2$1(_objectSpread2$1({}, actionDuring), {}, {
                type: afterName
              }),
              data: {
                exact: allMatches.after,
                namespaced: allMatches.afterNS
              },
              state: state,
              allPlugins: pluginObject,
              allMatches: allMatches,
              instance: instance,
              store: store,
              EVENTS: eventsInfo
            });

          case 26:
            actionAfter = _context.sent;

            // console.log('____ actionAfter', actionAfter)

            /* Fire callback if supplied */
            if (actionAfter.meta && actionAfter.meta.hasCallback) {
              /*
              console.log('End of engine action has callback')
              console.log(actionAfter.meta)
              console.log('stack', stack)
              /** */
              // @TODO figure out exact args calls and .on will get
              runCallback(actionAfter.meta.rid, {
                payload: actionAfter
              });
            }

          case 28:
            return _context.abrupt("return", actionBefore);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}

function processEvent(_x6) {
  return _processEvent.apply(this, arguments);
}

function _processEvent() {
  _processEvent = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(_ref2) {
    var data, action, instance, state, allPlugins, allMatches, store, EVENTS, plugins, context, method, isStartEvent, abortable, makeArgs, queueData, payloads, resolvedAction, endAction;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            data = _ref2.data, action = _ref2.action, instance = _ref2.instance, state = _ref2.state, allPlugins = _ref2.allPlugins, allMatches = _ref2.allMatches, store = _ref2.store, EVENTS = _ref2.EVENTS;
            plugins = state.plugins, context = state.context;
            method = action.type;
            isStartEvent = method.match(endsWithStartRegex); // console.log(`data ${method}`, data)
            // console.log(`data allMatches ${method}`, allMatches)

            abortable = data.exact.map(function (x) {
              return x.pluginName;
            });
            /* If abort is called from xyzStart */

            if (isStartEvent) {
              abortable = allMatches.during.map(function (x) {
                return x.pluginName;
              });
            }
            /* make args for functions to concume */


            makeArgs = argumentFactory(instance, abortable); // console.log('makeArgs', makeArgs)

            /* Check if plugin loaded, if not mark action for queue */

            queueData = data.exact.reduce(function (acc, thing) {
              var pluginName = thing.pluginName,
                  methodName = thing.methodName;
              var addToQueue = false; // Queue actions if plugin not loaded except for initialize and reset

              if (!methodName.match(/^initialize/) && !methodName.match(/^reset/)) {
                addToQueue = !plugins[pluginName].loaded;
              }
              /* If offline and its a core method. Add to queue */


              if (context.offline && methodName.match(/^(page|track|identify)/)) {
                addToQueue = true;
              }

              acc["".concat(pluginName)] = addToQueue;
              return acc;
            }, {});
            /* generate plugin specific payloads */

            _context5.next = 10;
            return data.exact.reduce( /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(scoped, curr, i) {
                var pluginName, curScope, scopedPayload;
                return regenerator.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        pluginName = curr.pluginName;
                        _context3.next = 3;
                        return scoped;

                      case 3:
                        curScope = _context3.sent;

                        if (!(data.namespaced && data.namespaced[pluginName])) {
                          _context3.next = 11;
                          break;
                        }

                        _context3.next = 7;
                        return data.namespaced[pluginName].reduce( /*#__PURE__*/function () {
                          var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(acc, p, count) {
                            var curScopeData, genAbort, val, returnValue;
                            return regenerator.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    genAbort = function _genAbort(currentAct, pname, otherPlug) {
                                      return function (reason, plugins) {
                                        var callsite = otherPlug || pname; // console.log(`__abort msg: ${reason}`)
                                        // console.log(`__abort ${pname}`)
                                        // console.log(`__abort xxx: ${plugins}`)
                                        // console.log(`__abort otherPlug`, otherPlug)

                                        // console.log(`__abort msg: ${reason}`)
                                        // console.log(`__abort ${pname}`)
                                        // console.log(`__abort xxx: ${plugins}`)
                                        // console.log(`__abort otherPlug`, otherPlug)
                                        return _objectSpread2$1(_objectSpread2$1({}, currentAct), {}, {
                                          abort: {
                                            reason: reason,
                                            plugins: plugins || [pname],
                                            caller: method,
                                            from: callsite
                                          }
                                        });
                                      };
                                    };

                                    _context2.next = 3;
                                    return acc;

                                  case 3:
                                    curScopeData = _context2.sent;

                                    if (!(!p.method || !_(p.method))) {
                                      _context2.next = 6;
                                      break;
                                    }

                                    return _context2.abrupt("return", curScopeData);

                                  case 6:
                                    /* Make sure plugins don’t call themselves */
                                    validateMethod(p.methodName, p.pluginName);
                                    _context2.next = 9;
                                    return p.method({
                                      payload: curScopeData,
                                      instance: instance,
                                      abort: genAbort(curScopeData, pluginName, p.pluginName),
                                      config: getConfig(p.pluginName, plugins, allPlugins),
                                      plugins: plugins
                                    });

                                  case 9:
                                    val = _context2.sent;
                                    returnValue = M(val) ? val : {};
                                    return _context2.abrupt("return", Promise.resolve(_objectSpread2$1(_objectSpread2$1({}, curScopeData), returnValue)));

                                  case 12:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));

                          return function (_x10, _x11, _x12) {
                            return _ref7.apply(this, arguments);
                          };
                        }(), Promise.resolve(action));

                      case 7:
                        scopedPayload = _context3.sent;

                        /* Set scoped payload */
                        curScope[pluginName] = scopedPayload;
                        _context3.next = 12;
                        break;

                      case 11:
                        /* Set payload as default action */
                        curScope[pluginName] = action;

                      case 12:
                        return _context3.abrupt("return", Promise.resolve(curScope));

                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x7, _x8, _x9) {
                return _ref6.apply(this, arguments);
              };
            }(), Promise.resolve({}));

          case 10:
            payloads = _context5.sent;
            _context5.next = 13;
            return data.exact.reduce( /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(promise, curr, i) {
                var lastLoop, pluginName, currentPlugin, currentActionValue, payloadValue, funcArgs, val, returnValue, merged, scopedPayload, nameSpaceEvent, actionDepth, updatedPayload;
                return regenerator.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        lastLoop = data.exact.length === i + 1;
                        pluginName = curr.pluginName;
                        currentPlugin = allPlugins[pluginName];
                        _context4.next = 5;
                        return promise;

                      case 5:
                        currentActionValue = _context4.sent;
                        payloadValue = payloads[pluginName] ? payloads[pluginName] : {};
                        /* If eventStart, allow for value merging */

                        /* If eventStart, allow for value merging */
                        if (isStartEvent) {
                          payloadValue = currentActionValue;
                        }

                        if (!shouldAbort(payloadValue, pluginName)) {
                          _context4.next = 11;
                          break;
                        }

                        // console.log(`> Abort from payload specific "${pluginName}" abort value`, payloadValue)
                        abortDispatch({
                          data: payloadValue,
                          method: method,
                          instance: instance,
                          pluginName: pluginName,
                          store: store
                        });
                        return _context4.abrupt("return", Promise.resolve(currentActionValue));

                      case 11:
                        if (!shouldAbort(currentActionValue, pluginName)) {
                          _context4.next = 14;
                          break;
                        }

                        // console.log(`> Abort from ${method} abort value`, currentActionValue)
                        if (lastLoop) {
                          abortDispatch({
                            data: currentActionValue,
                            method: method,
                            instance: instance,
                            // pluginName,
                            store: store
                          });
                        }

                        return _context4.abrupt("return", Promise.resolve(currentActionValue));

                      case 14:
                        if (!(queueData.hasOwnProperty(pluginName) && queueData[pluginName] === true)) {
                          _context4.next = 17;
                          break;
                        }

                        // console.log('Queue this instead', pluginName)
                        store.dispatch({
                          type: "queue",
                          plugin: pluginName,
                          payload: payloadValue,

                          /* Internal data for analytics engine */
                          _: {
                            called: "queue",
                            from: 'queueMechanism' // for debugging

                          }
                        });
                        return _context4.abrupt("return", Promise.resolve(currentActionValue));

                      case 17:
                        /*
                        const checkForLoaded = () => {
                          const p = instance.getState('plugins')
                          return p[currentPlugin.name].loaded
                        }
                        // const p = instance.getState('plugins')
                        console.log(`loaded "${currentPlugin.name}" > ${method}:`, p[currentPlugin.name].loaded)
                        // await waitForReady(currentPlugin, checkForLoaded, 10000).then((d) => {
                        //   console.log(`Loaded ${method}`, currentPlugin.name)
                        // }).catch((e) => {
                        //   console.log(`Error ${method} ${currentPlugin.name}`, e)
                        //   // TODO dispatch failure
                        // })
                        */
                        // @TODO figure out if we want queuing semantics
                        funcArgs = makeArgs(payloads[pluginName], allPlugins[pluginName]); // console.log(`funcArgs ${method} ${pluginName}`, funcArgs)

                        /* Run the plugin function */

                        _context4.next = 20;
                        return currentPlugin[method]({
                          // currentPlugin: pluginName,
                          abort: funcArgs.abort,
                          // Send in original action value or scope payload
                          payload: payloadValue,
                          instance: instance,
                          config: getConfig(pluginName, plugins, allPlugins),
                          plugins: plugins
                        });

                      case 20:
                        val = _context4.sent;
                        returnValue = M(val) ? val : {};
                        merged = _objectSpread2$1(_objectSpread2$1({}, currentActionValue), returnValue);
                        scopedPayload = payloads[pluginName]; // || currentActionValue

                        // || currentActionValue
                        if (shouldAbort(scopedPayload, pluginName)) {
                          // console.log(`>> HANDLE abort ${method} ${pluginName}`)
                          abortDispatch({
                            data: scopedPayload,
                            method: method,
                            instance: instance,
                            pluginName: pluginName,
                            store: store
                          });
                        } else {
                          nameSpaceEvent = "".concat(method, ":").concat(pluginName);
                          actionDepth = (nameSpaceEvent.match(/:/g) || []).length;

                          if (actionDepth < 2 && !method.match(bootstrapRegex) && !method.match(readyRegex)) {
                            updatedPayload = isStartEvent ? merged : payloadValue; // Dispatched for `.on('xyz') listeners.

                            // Dispatched for `.on('xyz') listeners.
                            instance.dispatch(_objectSpread2$1(_objectSpread2$1({}, updatedPayload), {}, {
                              type: nameSpaceEvent,
                              _: {
                                called: nameSpaceEvent,
                                from: 'submethod'
                              }
                            }));
                          }
                        } // console.log('merged', merged)


                        return _context4.abrupt("return", Promise.resolve(merged));

                      case 26:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x13, _x14, _x15) {
                return _ref8.apply(this, arguments);
              };
            }(), Promise.resolve(action));

          case 13:
            resolvedAction = _context5.sent;

            if (!(!method.match(endsWithStartRegex) && !method.match(/^registerPlugin/) && // !method.match(/^disablePlugin/) &&
            // !method.match(/^enablePlugin/) &&
            !method.match(readyRegex) && !method.match(bootstrapRegex) && !method.match(/^params/) && !method.match(/^userIdChanged/))) {
              _context5.next = 21;
              break;
            }

            if (EVENTS.plugins.includes(method)) ;
            /*
              Verify this original action setup.
              It's intended to keep actions from double dispatching themselves
            */


            if (!(resolvedAction._ && resolvedAction._.originalAction === method)) {
              _context5.next = 18;
              break;
            }

            return _context5.abrupt("return", resolvedAction);

          case 18:
            endAction = _objectSpread2$1(_objectSpread2$1({}, resolvedAction), {
              _: {
                originalAction: resolvedAction.type,
                called: resolvedAction.type,
                from: 'engineEnd'
              }
            });
            /* If all plugins are aborted, dispatch xAborted */

            if (shouldAbortAll(resolvedAction, data.exact.length) && !method.match(/End$/)) {
              endAction = _objectSpread2$1(_objectSpread2$1({}, endAction), {
                type: resolvedAction.type + 'Aborted'
              });
            }

            store.dispatch(endAction);

          case 21:
            return _context5.abrupt("return", resolvedAction);

          case 22:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _processEvent.apply(this, arguments);
}

function abortDispatch(_ref3) {
  var data = _ref3.data,
      method = _ref3.method;
      var pluginName = _ref3.pluginName,
      store = _ref3.store;
  var postFix = pluginName ? ':' + pluginName : '';
  var abortEvent = method + 'Aborted' + postFix;
  store.dispatch(_objectSpread2$1(_objectSpread2$1({}, data), {}, {
    type: abortEvent,
    _: {
      called: abortEvent,
      from: 'abort'
    }
  }));
}

function getConfig(name, pluginState, allPlugins) {
  var pluginData = pluginState[name] || allPlugins[name];

  if (pluginData && pluginData.config) {
    return pluginData.config;
  }

  return {};
}

function getPluginFunctions(methodName, plugins) {
  return plugins.reduce(function (arr, plugin) {
    return !plugin[methodName] ? arr : arr.concat({
      methodName: methodName,
      pluginName: plugin.name,
      method: plugin[methodName]
    });
  }, []);
}

function formatMethod(type) {
  return type.replace(endsWithStartRegex, '');
}
/**
 * Return array of event names
 * @param  {String} eventType - original event type
 * @param  {String} namespace - optional namespace postfix
 * @return {array} - type, method, end
 */


function getEventNames(eventType, namespace) {
  var method = formatMethod(eventType);
  var postFix = namespace ? ":".concat(namespace) : ''; // `typeStart:pluginName`

  var type = "".concat(eventType).concat(postFix); // `type:pluginName`

  var methodName = "".concat(method).concat(postFix); // `typeEnd:pluginName`

  var end = "".concat(method, "End").concat(postFix);
  return [type, methodName, end];
}
/* Collect all calls for a given event in the system */


function getAllMatchingCalls(eventType, activePlugins, allPlugins) {
  var eventNames = getEventNames(eventType); // console.log('eventNames', eventNames)
  // 'eventStart', 'event', & `eventEnd`

  var core = eventNames.map(function (word) {
    return getPluginFunctions(word, activePlugins);
  }); // Gather nameSpaced Events

  return activePlugins.reduce(function (acc, plugin) {
    var name = plugin.name;
    var nameSpacedEvents = getEventNames(eventType, name); // console.log('eventNames namespaced', nameSpacedEvents)

    var _nameSpacedEvents$map = nameSpacedEvents.map(function (word) {
      return getPluginFunctions(word, activePlugins);
    }),
        _nameSpacedEvents$map2 = _slicedToArray(_nameSpacedEvents$map, 3),
        beforeFuncs = _nameSpacedEvents$map2[0],
        duringFuncs = _nameSpacedEvents$map2[1],
        afterFuncs = _nameSpacedEvents$map2[2];

    if (beforeFuncs.length) {
      acc.beforeNS[name] = beforeFuncs;
    }

    if (duringFuncs.length) {
      acc.duringNS[name] = duringFuncs;
    }

    if (afterFuncs.length) {
      acc.afterNS[name] = afterFuncs;
    }

    return acc;
  }, {
    before: core[0],
    beforeNS: {},
    during: core[1],
    duringNS: {},
    after: core[2],
    afterNS: {}
  });
}

function shouldAbort(_ref4, pluginName) {
  var abort = _ref4.abort;
  if (!abort) return false;
  if (abort === true) return true;
  return includes(abort, pluginName) || abort && includes(abort.plugins, pluginName);
}

function shouldAbortAll(_ref5, pluginsCount) {
  var abort = _ref5.abort;
  if (!abort) return false;
  if (abort === true || L$1(abort)) return true;
  var plugins = abort.plugins;
  return isArray(abort) && abort.length === pluginsCount || isArray(plugins) && plugins.length === pluginsCount;
}

function isArray(arr) {
  return Array.isArray(arr);
}

function includes(arr, name) {
  if (!arr || !isArray(arr)) return false;
  return arr.includes(name);
}
/**
 * Generate arguments to pass to plugin methods
 * @param  {Object} instance - analytics instance
 * @param  {array} abortablePlugins - plugins that can be cancelled by caller
 * @return {*} function to inject plugin params
 */


function argumentFactory(instance, abortablePlugins) {
  // console.log('abortablePlugins', abortablePlugins)
  return function (action, plugin, otherPlugin) {
    var config = plugin.config,
        name = plugin.name;
    var method = "".concat(name, ".").concat(action.type);

    if (otherPlugin) {
      method = otherPlugin.event;
    }

    var abortF = action.type.match(endsWithStartRegex) ? abortFunction(name, method, abortablePlugins, otherPlugin, action) : notAbortableError(action, method);
    return {
      /* self: plugin, for future maybe */
      // clone objects to avoid reassign
      payload: formatPayload(action),
      instance: instance,
      config: config || {},
      abort: abortF
    };
  };
}

function abortFunction(pluginName, method, abortablePlugins, otherPlugin, action) {
  return function (reason, plugins) {
    var caller = otherPlugin ? otherPlugin.name : pluginName;
    var pluginsToAbort = plugins && isArray(plugins) ? plugins : abortablePlugins;

    if (otherPlugin) {
      pluginsToAbort = plugins && isArray(plugins) ? plugins : [pluginName];

      if (!pluginsToAbort.includes(pluginName) || pluginsToAbort.length !== 1) {
        throw new Error("Method ".concat(method, " can only abort ").concat(pluginName, " plugin. ").concat(JSON.stringify(pluginsToAbort), " input valid"));
      }
    }

    return _objectSpread2$1(_objectSpread2$1({}, action), {}, {
      // 🔥 todo verify this merge is ok
      abort: {
        reason: reason,
        plugins: pluginsToAbort,
        caller: method,
        _: caller
      }
    });
  };
}

function notAbortableError(action, method) {
  return function () {
    throw new Error(action.type + ' action not cancellable. Remove abort in ' + method);
  };
}
/**
 * Verify plugin is not calling itself with whatever:myPluginName self refs
 */


function validateMethod(actionName, pluginName) {
  var text = getNameSpacedAction(actionName);
  var methodCallMatchesPluginNamespace = text && text.name === pluginName;

  if (methodCallMatchesPluginNamespace) {
    var sub = getNameSpacedAction(text.method);
    var subText = sub ? 'or ' + sub.method : '';
    throw new Error([pluginName + ' plugin is calling method ' + actionName, 'Plugins cant call self', "Use ".concat(text.method, " ").concat(subText, " in ").concat(pluginName, " plugin insteadof ").concat(actionName)].join('\n'));
  }
}

function getNameSpacedAction(event) {
  var split = event.match(/(.*):(.*)/);

  if (!split) {
    return false;
  }

  return {
    method: split[1],
    name: split[2]
  };
}

function formatPayload(action) {
  return Object.keys(action).reduce(function (acc, key) {
    // redact type from { payload }
    if (key === 'type') {
      return acc;
    }

    if (M(action[key])) {
      acc[key] = Object.assign({}, action[key]);
    } else {
      acc[key] = action[key];
    }

    return acc;
  }, {});
}
/*
function getMatchingMethods(eventType, activePlugins) {
  const exact = getPluginFunctions(eventType, activePlugins)
  // console.log('exact', exact)
  // Gather nameSpaced Events
  return activePlugins.reduce((acc, plugin) => {
    const { name } = plugin
    const clean = getPluginFunctions(`${eventType}:${name}`, activePlugins)
    if (clean.length) {
      acc.namespaced[name] = clean
    }
    return acc
  }, {
    exact: exact,
    namespaced: {}
  })
}
*/

function pluginMiddleware(instance, getPlugins, systemEvents) {
  var isReady = {};
  return function (store) {
    return function (next) {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(action) {
          var type, abort, plugins, updatedAction, allPlugins, pluginsArray, allRegisteredPlugins, completed, failed, disabled, waitForPluginsToLoad, updated;
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  type = action.type, abort = action.abort, plugins = action.plugins;
                  updatedAction = action;

                  if (!abort) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", next(action));

                case 4:
                  /* Analytics.plugins.enable called, we need to init the plugins */
                  if (type === EVENTS$1.enablePlugin) {
                    store.dispatch({
                      type: EVENTS$1.initializeStart,
                      plugins: plugins,
                      disabled: [],
                      fromEnable: true,
                      meta: action.meta
                    });
                  }

                  if (type === EVENTS$1.disablePlugin) {
                    // If cached callback, resolve promise/run callback. debounced to fix race condition
                    setTimeout(function () {
                      return runCallback(action.meta.rid, {
                        payload: action
                      });
                    }, 0);
                  }
                  /* @TODO implement
                  if (type === EVENTS.loadPlugin) {
                    // Rerun initialize calls in plugins
                    const allPlugins = getPlugins()
                    const pluginsToLoad = Object.keys(allPlugins).filter((name) => {
                      return plugins.includes(name)
                    }).reduce((acc, curr) => {
                      acc[curr] = allPlugins[curr]
                      return acc
                    }, {})
                    const initializeAction = {
                      type: EVENTS.initializeStart,
                      plugins: plugins
                    }
                    const updated = await runPlugins(initializeAction, pluginsToLoad, instance, store, systemEvents)
                    return next(updated)
                  }
                  */
                  //  || type.match(/^initializeAbort:/)


                  if (type === EVENTS$1.initializeEnd) {
                    allPlugins = getPlugins();
                    pluginsArray = Object.keys(allPlugins);
                    allRegisteredPlugins = pluginsArray.filter(function (name) {
                      return plugins.includes(name);
                    }).map(function (name) {
                      return allPlugins[name];
                    });
                    completed = [];
                    failed = [];
                    disabled = action.disabled; // console.log('allRegisteredPlugins', allRegisteredPlugins)

                    waitForPluginsToLoad = allRegisteredPlugins.map(function (plugin) {
                      var loaded = plugin.loaded,
                          name = plugin.name;
                      /* Plugins will abort trying to load after 10 seconds. 1e4 === 10000 MS */

                      return waitForReady(plugin, loaded, 1e4).then(function (d) {
                        if (!isReady[name]) {
                          // only dispatch namespaced rdy once
                          store.dispatch({
                            type: EVENTS$1.pluginReadyType(name),
                            // `ready:${name}`
                            name: name,
                            events: Object.keys(plugin).filter(function (name) {
                              return !nonEvents.includes(name);
                            })
                          });
                          isReady[name] = true;
                        }

                        completed = completed.concat(name);
                        return plugin; // It's loaded! run the command
                      })["catch"](function (e) {
                        // Timeout Add to queue
                        // console.log('Error generic waitForReady. Push this to queue', e)
                        if (e instanceof Error) {
                          throw new Error(e);
                        }

                        failed = failed.concat(e.name); // Failed to fire, add to queue

                        return e;
                      });
                    });
                    Promise.all(waitForPluginsToLoad).then(function (calls) {
                      // setTimeout to ensure runs after 'page'
                      var payload = {
                        plugins: completed,
                        failed: failed,
                        disabled: disabled
                      };
                      setTimeout(function () {
                        if (pluginsArray.length === waitForPluginsToLoad.length + disabled.length) {
                          store.dispatch(_objectSpread2$1(_objectSpread2$1({}, {
                            type: EVENTS$1.ready
                          }), payload));
                        }
                      }, 0);
                    });
                  }
                  /* New plugin system */


                  if (!(type !== EVENTS$1.bootstrap)) {
                    _context.next = 13;
                    break;
                  }

                  if (/^ready:([^:]*)$/.test(type)) {
                    // Immediately flush queue
                    setTimeout(function () {
                      return processQueue(store, getPlugins, instance);
                    }, 0);
                  }

                  _context.next = 11;
                  return runPlugins(action, getPlugins, instance, store, systemEvents);

                case 11:
                  updated = _context.sent;
                  return _context.abrupt("return", next(updated));

                case 13:
                  return _context.abrupt("return", next(updatedAction));

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    };
  };
}

function storageMiddleware(storage) {
  return function (store) {
    return function (next) {
      return function (action) {
        var type = action.type,
            key = action.key,
            value = action.value,
            options = action.options;

        if (type === EVENTS$1.setItem || type === EVENTS$1.removeItem) {
          if (action.abort) {
            return next(action);
          } // Run storage set or remove


          if (type === EVENTS$1.setItem) {
            storage.setItem(key, value, options);
          } else {
            storage.removeItem(key, options);
          }
        }

        return next(action);
      };
    };
  };
}
/*
  Todo: emit events for keys we care about
  window.addEventListener('storage', (event) => console.log(event));
*/

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/* Class to fix dynamic middlewares from conflicting with each other
if more than one analytic instance is active */

var DynamicMiddleware = /*#__PURE__*/_createClass(function DynamicMiddleware() {
  var _this = this;

  _classCallCheck(this, DynamicMiddleware);

  _defineProperty$1(this, "before", []);

  _defineProperty$1(this, "after", []);

  _defineProperty$1(this, "addMiddleware", function (middlewares, position) {
    _this[position] = _this[position].concat(middlewares);
  });

  _defineProperty$1(this, "removeMiddleware", function (middleware, position) {
    var index = _this[position].findIndex(function (d) {
      return d === middleware;
    });

    if (index === -1) return;
    _this[position] = [].concat(_toConsumableArray(_this[position].slice(0, index)), _toConsumableArray(_this[position].slice(index + 1)));
  });

  _defineProperty$1(this, "dynamicMiddlewares", function (position) {
    return function (store) {
      return function (next) {
        return function (action) {
          var middlewareAPI = {
            getState: store.getState,
            dispatch: function dispatch(act) {
              return store.dispatch(act);
            }
          };

          var chain = _this[position].map(function (middleware) {
            return middleware(middlewareAPI);
          });

          return compose.apply(void 0, _toConsumableArray(chain))(next)(action);
        };
      };
    };
  });
});

function createReducer(getPlugins) {
  return function plugins() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var newState = {};

    if (action.type === 'initialize:aborted') {
      return state;
    }

    if (/^registerPlugin:([^:]*)$/.test(action.type)) {
      var name = getNameFromEventType(action.type, 'registerPlugin');
      var plugin = getPlugins()[name];

      if (!plugin || !name) {
        return state;
      }

      var isEnabled = action.enabled;
      newState[name] = {
        enabled: isEnabled,

        /* if no initialization method. Set initialized true */
        initialized: isEnabled ? Boolean(!plugin.initialize) : false,

        /* If plugin enabled === false, set loaded to false, else check plugin.loaded function */
        loaded: isEnabled ? Boolean(plugin.loaded()) : false,
        config: plugin.config || {}
      };
      return _objectSpread2$1(_objectSpread2$1({}, state), newState);
    }

    if (/^initialize:([^:]*)$/.test(action.type)) {
      var _name = getNameFromEventType(action.type, EVENTS$1.initialize);

      var _plugin = getPlugins()[_name];

      if (!_plugin || !_name) {
        return state;
      }

      newState[_name] = _objectSpread2$1(_objectSpread2$1({}, state[_name]), {
        initialized: true,

        /* check plugin.loaded function */
        loaded: Boolean(_plugin.loaded())
      });
      return _objectSpread2$1(_objectSpread2$1({}, state), newState);
    }

    if (/^ready:([^:]*)$/.test(action.type)) {
      // const name = getNameFromEventType(action.type, 'ready')
      newState[action.name] = _objectSpread2$1(_objectSpread2$1({}, state[action.name]), {
        loaded: true
      });
      return _objectSpread2$1(_objectSpread2$1({}, state), newState);
    }

    switch (action.type) {
      /* case EVENTS.pluginFailed:
        // console.log('PLUGIN_FAILED', action.name)
        newState[action.name] = {
          ...state[action.name],
          ...{ loaded: false }
        }
        return { ...state, ...newState }
      */

      /* When analytics.plugins.disable called */
      case EVENTS$1.disablePlugin:
        return _objectSpread2$1(_objectSpread2$1({}, state), togglePluginStatus(action.plugins, false, state));

      /* When analytics.plugins.enable called */

      case EVENTS$1.enablePlugin:
        return _objectSpread2$1(_objectSpread2$1({}, state), togglePluginStatus(action.plugins, true, state));

      default:
        return state;
    }
  };
}

function getNameFromEventType(type, baseName) {
  return type.substring(baseName.length + 1, type.length);
}

function togglePluginStatus(plugins, status, currentState) {
  return plugins.reduce(function (acc, pluginKey) {
    acc[pluginKey] = _objectSpread2$1(_objectSpread2$1({}, currentState[pluginKey]), {
      enabled: status
    });
    return acc;
  }, currentState);
}

function serialize(obj) {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (err) {}

  return obj;
}

var initialState$3 = {
  last: {},
  history: []
}; // track reducer

function trackReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      event = action.event,
      properties = action.properties,
      options = action.options,
      meta = action.meta;

  switch (type) {
    case EVENTS$1.track:
      var trackEvent = serialize(_objectSpread2$1(_objectSpread2$1({
        event: event,
        properties: properties
      }, Object.keys(options).length && {
        options: options
      }), {}, {
        meta: meta
      }));
      return _objectSpread2$1(_objectSpread2$1({}, state), {
        last: trackEvent,
        // Todo prevent LARGE arrays https://bit.ly/2MnBwPT
        history: state.history.concat(trackEvent)
      });

    default:
      return state;
  }
}

/*
TODO figure out if this should live in state...
Queue could be in mermory as well.
But also needs to be persisted to storage
*/

var initialState$2 = {
  actions: []
};
function queueReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'queue':
      var actionChain;
      /* prioritize identify in event queue */

      if (payload && payload.type && payload.type === EVENTS$1.identify) {
        actionChain = [action].concat(state.actions);
      } else {
        actionChain = state.actions.concat(action);
      }

      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        actions: actionChain
      });

    case 'dequeue':
      return [];
    // todo push events to history

    default:
      return state;
  }
}

var hashRegex = /#.*$/;

function canonicalUrl() {
  if (!z) return;
  var tags = document.getElementsByTagName('link');

  for (var i = 0, tag; tag = tags[i]; i++) {
    if (tag.getAttribute('rel') === 'canonical') {
      return tag.getAttribute('href');
    }
  }
}

function urlPath(url) {
  var regex = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g;
  var matches = regex.exec(url);
  var pathMatch = matches && matches[3] ? matches[3].split('?')[0].replace(hashRegex, '') : '';
  return '/' + pathMatch;
}
/**
 * Return the canonical URL and rmove the hash.
 * @param  {string} search - search param
 * @return {string} return current canonical URL
 */


function currentUrl(search) {
  var canonical = canonicalUrl();
  if (!canonical) return window.location.href.replace(hashRegex, '');
  return canonical.match(/\?/) ? canonical : canonical + search;
}
/**
 * Page data for overides
 * @typedef {object} PageData
 * @property {string} [title] - Page title
 * @property {string} [url] - Page url
 * @property {string} [path] - Page path
 * @property {string} [search] - Page search
 * @property {string} [width] - Page width
 * @property {string} [height] - Page height
*/

/**
 * Get information about current page
 * @typedef {Function} getPageData
 * @param  {PageData} [pageData = {}] - Page data overides
 * @return {PageData} resolved page data
 */


var getPageData = function getPageData() {
  var pageData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!z) return pageData;
  var _document = document,
      title = _document.title,
      referrer = _document.referrer;
  var _window = window,
      location = _window.location,
      innerWidth = _window.innerWidth,
      innerHeight = _window.innerHeight;
  var hash = location.hash,
      search = location.search;
  var url = currentUrl(search);
  var page = {
    title: title,
    url: url,
    path: urlPath(url),
    hash: hash,
    search: search,
    width: innerWidth,
    height: innerHeight
  };

  if (referrer && referrer !== '') {
    page.referrer = referrer;
  }

  return _objectSpread2$1(_objectSpread2$1({}, page), pageData);
};
var initialState$1 = {
  last: {},
  history: []
}; // page reducer

function page() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var properties = action.properties,
      options = action.options,
      meta = action.meta;

  switch (action.type) {
    case EVENTS$1.page:
      var viewData = serialize(_objectSpread2$1({
        properties: properties,
        meta: meta
      }, Object.keys(options).length && {
        options: options
      }));
      return _objectSpread2$1(_objectSpread2$1({}, state), {
        last: viewData,
        // Todo prevent LARGE arrays https://bit.ly/2MnBwPT
        history: state.history.concat(viewData)
      });

    default:
      return state;
  }
}

function getBrowserOS() {
  if (!z) return false;
  var os = navigator.appVersion; // ~os bitwise operator to check if in navigator

  if (~os.indexOf('Win')) return 'Windows';
  if (~os.indexOf('Mac')) return 'MacOS';
  if (~os.indexOf('X11')) return 'UNIX';
  if (~os.indexOf('Linux')) return 'Linux'; // default

  return 'Unknown OS';
}

var osName;
var referrer;
var locale;
var timeZone;

{
  osName = getBrowserOS();
  referrer = z ? document.referrer : null;
  locale = o$2();
  timeZone = a$3();
}

var initialState = {
  initialized: false,
  sessionId: y(),
  app: null,
  version: null,
  debug: false,
  offline: z ? !navigator.onLine : false,
  // use node network is-online
  os: {
    name: osName
  },
  userAgent: z ? navigator.userAgent : 'node',
  // https://github.com/bestiejs/platform.js
  library: {
    name: LIB_NAME,
    // TODO fix version number. npm run publish:patch has wrong version
    version: "0.10.22"
  },
  timezone: timeZone,
  locale: locale,
  campaign: {},
  referrer: referrer
}; // context reducer

function context() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var initialized = state.initialized;
  var type = action.type,
      campaign = action.campaign;

  switch (type) {
    case EVENTS$1.campaign:
      return _objectSpread2$1(_objectSpread2$1({}, state), {
        campaign: campaign
      });

    case EVENTS$1.offline:
      return _objectSpread2$1(_objectSpread2$1({}, state), {
        offline: true
      });

    case EVENTS$1.online:
      return _objectSpread2$1(_objectSpread2$1({}, state), {
        offline: false
      });

    default:
      if (!initialized) {
        return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, initialState), state), {
          initialized: true
        });
      }

      return state;
  }
}
var excludeItems = ['plugins', 'reducers', 'storage']; // Pull plugins and reducers off intital config

function makeContext(config) {
  return Object.keys(config).reduce(function (acc, current) {
    if (excludeItems.includes(current)) {
      return acc;
    }

    acc[current] = config[current];
    return acc;
  }, {});
}

function listen(events, func, toAdd) {
  if (!z) return;
  var fn = window[(toAdd ? 'add' : 'remove') + 'EventListener'];
  events.split(' ').forEach(function (ev) {
    fn(ev, func);
  });
}

function check() {
  return Promise.resolve(!navigator.onLine);
}
function watch(cb) {
  var fn = function fn(_) {
    return check().then(cb);
  };

  var listener = listen.bind(null, 'online offline', fn);
  listener(true); // return unsubscribe function

  return function (_) {
    return listener(false);
  };
}

function Debug() {
  // Global key is window.__global__.analytics
  f$1(LIB_NAME, []); // Return debugger

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var origDispatch = store.dispatch;

      var dispatch = function dispatch(action) {
        var a = action.action || action;
        n[o][LIB_NAME].push(a);
        return origDispatch(action);
      };

      return Object.assign(store, {
        dispatch: dispatch
      });
    };
  };
}
function composeWithDebug(config) {
  return function () {
    return compose(compose.apply(null, arguments), Debug());
  };
}

function ensureArray(singleOrArray) {
  if (!singleOrArray) return [];
  if (G$1(singleOrArray)) return singleOrArray;
  return [singleOrArray];
}

/**
 * Grab first function found from arguments
 * @param {array} [argArray] - arguments array to find first function
 * @returns {Function|undefined}
 */

function getCallbackFromArgs(argArray) {
  var args = argArray || Array.prototype.slice.call(arguments);
  var cb;

  for (var i = 0; i < args.length; i++) {
    if (_(args[i])) {
      cb = args[i];
      break;
    }
  }

  return cb;
}

function timeStamp() {
  return new Date().getTime();
}

function deferredPromiseResolver(resolver, callback) {
  return function (data) {
    if (callback) callback(data);
    resolver(data);
  };
}

function generateMeta() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var resolve = arguments.length > 1 ? arguments[1] : undefined;
  var possibleCallbacks = arguments.length > 2 ? arguments[2] : undefined;
  var rid = y();

  if (resolve) {
    // stack[`${rid}-info`] = meta
    stack[rid] = deferredPromiseResolver(resolve, getCallbackFromArgs(possibleCallbacks));
  }

  return _objectSpread2$1(_objectSpread2$1({}, meta), {}, {
    rid: rid,
    ts: timeStamp()
  }, !resolve ? {} : {
    hasCallback: true
  });
}

/**
 * Analytics library configuration
 *
 * After the library is initialized with config, the core API is exposed & ready for use in the application.
 *
 * @param {object} config - analytics core config
 * @param {string} [config.app] - Name of site / app
 * @param {string} [config.version] - Version of your app
 * @param {boolean} [config.debug] - Should analytics run in debug mode
 * @param {Array.<AnalyticsPlugin>}  [config.plugins] - Array of analytics plugins
 * @return {AnalyticsInstance} Analytics Instance
 * @example
 *
 * import Analytics from 'analytics'
 * import pluginABC from 'analytics-plugin-abc'
 * import pluginXYZ from 'analytics-plugin-xyz'
 *
 * // initialize analytics
 * const analytics = Analytics({
 *   app: 'my-awesome-app',
 *   plugins: [
 *     pluginABC,
 *     pluginXYZ
 *   ]
 * })
 *
 */

function analytics$1() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customReducers = config.reducers || {};
  var initialUser = config.initialUser || {}; // @TODO add custom value reolvers for userId and anonId
  // const resolvers = config.resolvers || {}

  /* Parse plugins array */

  var parsedOptions = (config.plugins || []).reduce(function (acc, plugin) {
    if (_(plugin)) {
      /* Custom redux middleware */
      acc.middlewares = acc.middlewares.concat(plugin);
      return acc;
    } // Legacy plugin with name


    if (plugin.NAMESPACE) plugin.name = plugin.NAMESPACE;

    if (!plugin.name) {
      /* Plugins must supply a "name" property. See error url for more details */
      throw new Error(ERROR_URL + '1');
    } // if plugin exposes EVENTS capture available events


    var definedEvents = plugin.EVENTS ? Object.keys(plugin.EVENTS).map(function (k) {
      return plugin.EVENTS[k];
    }) : [];
    var enabledFromMerge = !(plugin.enabled === false);
    var enabledFromPluginConfig = !(plugin.config && plugin.config.enabled === false); // top level { enabled: false } takes presidence over { config: enabled: false }

    acc.pluginEnabled[plugin.name] = enabledFromMerge && enabledFromPluginConfig;
    delete plugin.enabled;

    if (plugin.methods) {
      acc.methods[plugin.name] = Object.keys(plugin.methods).reduce(function (a, c) {
        // enrich methods with analytics instance
        a[c] = appendArguments(plugin.methods[c]);
        return a;
      }, {}); // Remove additional methods from plugins

      delete plugin.methods;
    } // Convert available methods into events


    var methodsToEvents = Object.keys(plugin); // Combine events

    var allEvents = methodsToEvents.concat(definedEvents); // Dedupe events list

    var allEventsUnique = new Set(acc.events.concat(allEvents));
    acc.events = Array.from(allEventsUnique);
    acc.pluginsArray = acc.pluginsArray.concat(plugin);

    if (acc.plugins[plugin.name]) {
      throw new Error(plugin.name + 'AlreadyLoaded');
    }

    acc.plugins[plugin.name] = plugin;

    if (!acc.plugins[plugin.name].loaded) {
      // set default loaded func
      acc.plugins[plugin.name].loaded = function () {
        return true;
      };
    }

    return acc;
  }, {
    plugins: {},
    pluginEnabled: {},
    methods: {},
    pluginsArray: [],
    middlewares: [],
    events: []
  });
  /* Storage by default is set to global & is not persisted */

  var storage = config.storage ? config.storage : {
    getItem: a$2,
    setItem: f$1,
    removeItem: i$2
  };
  var getUserProp = getUserPropFunc(storage); // mutable intregrations object for dynamic loading

  var customPlugins = parsedOptions.plugins;
  /* Grab all registered events from plugins loaded */

  var allPluginEvents = parsedOptions.events.filter(function (name) {
    return !nonEvents.includes(name);
  }).sort();
  var uniqueEvents = new Set(allPluginEvents.concat(coreEvents).filter(function (name) {
    return !nonEvents.includes(name);
  }));
  var allSystemEvents = Array.from(uniqueEvents).sort();
  /* plugin methods(functions) must be kept out of state. thus they live here */

  var getPlugins = function getPlugins() {
    return customPlugins;
  };

  var _DynamicMiddleware = new DynamicMiddleware(),
      addMiddleware = _DynamicMiddleware.addMiddleware,
      removeMiddleware = _DynamicMiddleware.removeMiddleware,
      dynamicMiddlewares = _DynamicMiddleware.dynamicMiddlewares;

  var nonAbortable = function nonAbortable() {
    // throw new Error(`${ERROR_URL}3`)
    throw new Error('Abort disabled inListener');
  }; // Parse URL parameters


  var params = s(); // Initialize visitor information

  var persistedUser = getPersistedUserData(storage);

  var visitorInfo = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, persistedUser), initialUser), !params.an_uid ? {} : {
    userId: params.an_uid
  }), !params.an_aid ? {} : {
    anonymousId: params.an_aid
  }); // If no anon id set, create one


  if (!visitorInfo.anonymousId) {
    visitorInfo.anonymousId = y();
  }
  /**
   * Async Management methods for plugins. 
   * 
   * This is also where [custom methods](https://bit.ly/329vFXy) are loaded into the instance.
   * @typedef {Object} Plugins
   * @property {EnablePlugin} enable - Set storage value
   * @property {DisablePlugin} disable - Remove storage value
   * @example
   *
   * // Enable a plugin by namespace
   * analytics.plugins.enable('keenio')
   *
   * // Disable a plugin by namespace
   * analytics.plugins.disable('google-analytics')
   */


  var plugins = _objectSpread2$1({
    /**
     * Enable analytics plugin
     * @typedef {Function} EnablePlugin
     * @param  {string|string[]} plugins - name of plugins(s) to disable
     * @param  {Function} [callback] - callback after enable runs
     * @returns {Promise}
     * @example
     *
     * analytics.plugins.enable('google-analytics').then(() => {
     *   console.log('do stuff')
     * })
     *
     * // Enable multiple plugins at once
     * analytics.plugins.enable(['google-analytics', 'segment']).then(() => {
     *   console.log('do stuff')
     * })
     */
    enable: function enable(plugins, callback) {
      return new Promise(function (resolve) {
        store.dispatch({
          type: EVENTS$1.enablePlugin,
          plugins: ensureArray(plugins),
          _: {
            originalAction: EVENTS$1.enablePlugin
          }
        }, resolve, [callback]);
      });
    },

    /**
     * Disable analytics plugin
     * @typedef {Function} DisablePlugin
     * @param  {string|string[]} plugins - name of integration(s) to disable
     * @param  {Function} callback - callback after disable runs
     * @returns {Promise}
     * @example
     *
     * analytics.plugins.disable('google').then(() => {
     *   console.log('do stuff')
     * })
     *
     * analytics.plugins.disable(['google', 'segment']).then(() => {
     *   console.log('do stuff')
     * })
     */
    disable: function disable(plugins, callback) {
      return new Promise(function (resolve) {
        store.dispatch({
          type: EVENTS$1.disablePlugin,
          plugins: ensureArray(plugins),
          _: {
            originalAction: EVENTS$1.disablePlugin
          }
        }, resolve, [callback]);
      });
    }
  }, parsedOptions.methods);
  /**
   * Analytic instance returned from initialization
   * @typedef {Object} AnalyticsInstance
   * @property {Identify} identify - Identify a user
   * @property {Track} track - Track an analytics event
   * @property {Page} page - Trigger page view
   * @property {User} user - Get user data
   * @property {Reset} reset - Clear information about user & reset analytics
   * @property {Ready} ready - Fire callback on analytics ready event
   * @property {On} on - Fire callback on analytics lifecycle events.
   * @property {Once} once - Fire callback on analytics lifecycle events once.
   * @property {GetState} getState - Get data about user, activity, or context.
   * @property {Storage} storage - storage methods
   * @property {Plugins} plugins - plugin methods
   */


  var instance = {
    /**
    * Identify a user. This will trigger `identify` calls in any installed plugins and will set user data in localStorage
    * @typedef {Function} Identify
    * @param  {String}   userId  - Unique ID of user
    * @param  {Object}   [traits]  - Object of user traits
    * @param  {Object}   [options] - Options to pass to identify call
    * @param  {Function} [callback] - Callback function after identify completes
    * @returns {Promise}
    * @api public
    *
    * @example
    *
    * // Basic user id identify
    * analytics.identify('xyz-123')
    *
    * // Identify with additional traits
    * analytics.identify('xyz-123', {
    *   name: 'steve',
    *   company: 'hello-clicky'
    * })
    *
    * // Fire callback with 2nd or 3rd argument
    * analytics.identify('xyz-123', () => {
    *   console.log('do this after identify')
    * })
    *
    * // Disable sending user data to specific analytic tools
    * analytics.identify('xyz-123', {}, {
    *   plugins: {
    *     // disable sending this identify call to segment
    *     segment: false
    *   }
    * })
    *
    * // Send user data to only to specific analytic tools
    * analytics.identify('xyz-123', {}, {
    *   plugins: {
    *     // disable this specific identify in all plugins except customerio
    *     all: false,
    *     customerio: true
    *   }
    * })
    */
    identify: function () {
      var _identify = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(userId, traits, options, callback) {
        var id, data, opts, user, resolvedId;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = L$1(userId) ? userId : null;
                data = M(userId) ? userId : traits;
                opts = options || {};
                user = instance.user();
                /* sets temporary in memory id. Not to be relied on */

                f$1(tempKey(ID), id);
                resolvedId = id || data.userId || getUserProp(ID, instance, data);
                return _context.abrupt("return", new Promise(function (resolve) {
                  store.dispatch(_objectSpread2$1({
                    type: EVENTS$1.identifyStart,
                    userId: resolvedId,
                    traits: data || {},
                    options: opts,
                    anonymousId: user.anonymousId
                  }, user.id && user.id !== id && {
                    previousId: user.id
                  }), resolve, [traits, options, callback]);
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function identify(_x, _x2, _x3, _x4) {
        return _identify.apply(this, arguments);
      }

      return identify;
    }(),

    /**
     * Track an analytics event. This will trigger `track` calls in any installed plugins
     * @typedef {Function} Track
     * @param  {String}   eventName - Event name
     * @param  {Object}   [payload]   - Event payload
     * @param  {Object}   [options]   - Event options
     * @param  {Function} [callback]  - Callback to fire after tracking completes
     * @returns {Promise}
     * @api public
     *
     * @example
     *
     * // Basic event tracking
     * analytics.track('buttonClicked')
     *
     * // Event tracking with payload
     * analytics.track('itemPurchased', {
     *   price: 11,
     *   sku: '1234'
     * })
     *
     * // Fire callback with 2nd or 3rd argument
     * analytics.track('newsletterSubscribed', () => {
     *   console.log('do this after track')
     * })
     *
     * // Disable sending this event to specific analytic tools
     * analytics.track('cartAbandoned', {
     *   items: ['xyz', 'abc']
     * }, {
     *   plugins: {
     *     // disable track event for segment
     *     segment: false
     *   }
     * })
     *
     * // Send event to only to specific analytic tools
     * analytics.track('customerIoOnlyEventExample', {
     *   price: 11,
     *   sku: '1234'
     * }, {
     *   plugins: {
     *     // disable this specific track call all plugins except customerio
     *     all: false,
     *     customerio: true
     *   }
     * })
     */
    track: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(eventName, payload, options, callback) {
        var name, data, opts;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                name = M(eventName) ? eventName.event : eventName;

                if (!(!name || !L$1(name))) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('EventMissing');

              case 3:
                data = M(eventName) ? eventName : payload || {};
                opts = M(options) ? options : {};
                return _context2.abrupt("return", new Promise(function (resolve) {
                  store.dispatch({
                    type: EVENTS$1.trackStart,
                    event: name,
                    properties: data,
                    options: opts,
                    userId: getUserProp(ID, instance, payload),
                    anonymousId: getUserProp(ANONID, instance, payload)
                  }, resolve, [payload, options, callback]);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function track(_x5, _x6, _x7, _x8) {
        return _track.apply(this, arguments);
      }

      return track;
    }(),

    /**
     * Trigger page view. This will trigger `page` calls in any installed plugins
     * @typedef {Function} Page
     * @param  {PageData} [data] - Page data overrides.
     * @param  {Object}   [options] - Page tracking options
     * @param  {Function} [callback] - Callback to fire after page view call completes
     * @returns {Promise}
     * @api public
     *
     * @example
     *
     * // Basic page tracking
     * analytics.page()
     *
     * // Page tracking with page data overrides
     * analytics.page({
     *   url: 'https://google.com'
     * })
     *
     * // Fire callback with 1st, 2nd or 3rd argument
     * analytics.page(() => {
     *   console.log('do this after page')
     * })
     *
     * // Disable sending this pageview to specific analytic tools
     * analytics.page({}, {
     *   plugins: {
     *     // disable page tracking event for segment
     *     segment: false
     *   }
     * })
     *
     * // Send pageview to only to specific analytic tools
     * analytics.page({}, {
     *   plugins: {
     *     // disable this specific page in all plugins except customerio
     *     all: false,
     *     customerio: true
     *   }
     * })
     */
    page: function () {
      var _page = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(data, options, callback) {
        var d, opts;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                d = M(data) ? data : {};
                opts = M(options) ? options : {};
                /*
                // @TODO add custom value reolvers for userId and anonId
                if (resolvers.getUserId) {
                  const asyncUserId = await resolvers.getUserId()
                  console.log('x', x)
                }
                */

                return _context3.abrupt("return", new Promise(function (resolve) {
                  store.dispatch({
                    type: EVENTS$1.pageStart,
                    properties: getPageData(d),
                    options: opts,
                    userId: getUserProp(ID, instance, d),
                    anonymousId: getUserProp(ANONID, instance, d)
                  }, resolve, [data, options, callback]);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function page(_x9, _x10, _x11) {
        return _page.apply(this, arguments);
      }

      return page;
    }(),

    /**
     * Get user data
     * @typedef {Function} User
     * @param {string} [key] - dot.prop.path of user data. Example: 'traits.company.name'
     * @returns {string|object} value of user data or null
     *
     * @example
     *
     * // Get all user data
     * const userData = analytics.user()
     *
     * // Get user id
     * const userId = analytics.user('userId')
     *
     * // Get user company name
     * const companyName = analytics.user('traits.company.name')
     */
    user: function user(key) {
      if (key === ID || key === 'id') {
        return getUserProp(ID, instance);
      }

      if (key === ANONID || key === 'anonId') {
        return getUserProp(ANONID, instance);
      }

      var user = instance.getState('user');
      if (!key) return user;
      return dlv_umd(user, key);
    },

    /**
     * Clear all information about the visitor & reset analytic state.
     * @typedef {Function} Reset
     * @param {Function} [callback] - Handler to run after reset
     * @returns {Promise}
     * @example
     *
     * // Reset current visitor
     * analytics.reset()
     */
    reset: function reset(callback) {
      return new Promise(function (resolve) {
        store.dispatch({
          type: EVENTS$1.resetStart
        }, resolve, callback);
      });
    },

    /**
     * Fire callback on analytics ready event
     * @typedef {Function} Ready
     * @param  {Function} callback - function to trigger when all providers have loaded
     * @returns {DetachListeners} - Function to detach listener
     *
     * @example
     *
     * analytics.ready((payload) => {
     *   console.log('all plugins have loaded or were skipped', payload);
     * })
     */
    ready: function ready(callback) {
      return instance.on(EVENTS$1.ready, callback);
    },

    /**
     * Attach an event handler function for analytics lifecycle events.
     * @typedef {Function} On
     * @param  {String}   name - Name of event to listen to
     * @param  {Function} callback - function to fire on event
     * @return {DetachListeners} - Function to detach listener
     *
     * @example
     *
     * // Fire function when 'track' calls happen
     * analytics.on('track', ({ payload }) => {
     *   console.log('track call just happened. Do stuff')
     * })
     *
     * // Remove listener before it is called
     * const removeListener = analytics.on('track', ({ payload }) => {
     *   console.log('This will never get called')
     * })
     *
     * // cleanup .on listener
     * removeListener()
     */
    on: function on(name, callback) {
      if (!name || !_(callback)) {
        return false;
      }

      if (name === EVENTS$1.bootstrap) {
        throw new Error('.on disabled for ' + name);
      }

      var startRegex = /Start$|Start:/;

      if (name === '*') {
        var beforeHandler = function beforeHandler(store) {
          return function (next) {
            return function (action) {
              if (action.type.match(startRegex)) {
                callback({
                  // eslint-disable-line
                  payload: action,
                  instance: instance,
                  plugins: customPlugins
                });
              }

              return next(action);
            };
          };
        };

        var afterHandler = function afterHandler(store) {
          return function (next) {
            return function (action) {
              if (!action.type.match(startRegex)) {
                callback({
                  // eslint-disable-line
                  payload: action,
                  instance: instance,
                  plugins: customPlugins
                });
              }

              return next(action);
            };
          };
        };

        addMiddleware(beforeHandler, before);
        addMiddleware(afterHandler, after);
        /**
         * Detach listeners
         * @typedef {Function} DetachListeners
         */

        return function () {
          removeMiddleware(beforeHandler, before);
          removeMiddleware(afterHandler, after);
        };
      }

      var position = name.match(startRegex) ? before : after; // eslint-disable-line

      var handler = function handler(store) {
        return function (next) {
          return function (action) {
            // Subscribe to EVERYTHING
            if (action.type === name) {
              callback({
                // eslint-disable-line
                payload: action,
                instance: instance,
                plugins: customPlugins,
                abort: nonAbortable
              });
            }
            /* For future matching of event subpaths `track:*` etc
            } else if (name.match(/\*$/)) {
              const match = (name === '*') ? '.' : name
              const regex = new RegExp(`${match}`, 'g')
            } */


            return next(action);
          };
        };
      };

      addMiddleware(handler, position);
      return function () {
        return removeMiddleware(handler, position);
      };
    },

    /**
     * Attach a handler function to an event and only trigger it only once.
     * @typedef {Function} Once
     * @param  {String} name - Name of event to listen to
     * @param  {Function} callback - function to fire on event
     * @return {DetachListeners} - Function to detach listener
     *
     * @example
     *
     * // Fire function only once 'track'
     * analytics.once('track', ({ payload }) => {
     *   console.log('This will only triggered once when analytics.track() fires')
     * })
     *
     * // Remove listener before it is called
     * const listener = analytics.once('track', ({ payload }) => {
     *   console.log('This will never get called b/c listener() is called')
     * })
     *
     * // cleanup .once listener before it fires
     * listener()
     */
    once: function once(name, callback) {
      if (!name || !_(callback)) {
        return false;
      }

      if (name === EVENTS$1.bootstrap) {
        throw new Error('.once disabled for ' + name);
      }

      var detachListener = instance.on(name, function (_ref) {
        var payload = _ref.payload;
        callback({
          // eslint-disable-line
          payload: payload,
          instance: instance,
          plugins: customPlugins,
          abort: nonAbortable
        }); // detach listener after its called once

        detachListener();
      });
      return detachListener;
    },

    /**
     * Get data about user, activity, or context. Access sub-keys of state with `dot.prop` syntax.
     * @typedef {Function} GetState
     * @param  {string} [key] - dot.prop.path value of state
     * @return {any}
     *
     * @example
     *
     * // Get the current state of analytics
     * analytics.getState()
     *
     * // Get a subpath of state
     * analytics.getState('context.offline')
     */
    getState: function getState(key) {
      var state = store.getState();
      if (key) return dlv_umd(state, key);
      return Object.assign({}, state);
    },

    /*
     * Emit events for other plugins or middleware to react to.
     * @param  {Object} action - event to dispatch
     */
    dispatch: function dispatch(action) {
      var actionData = L$1(action) ? {
        type: action
      } : action;

      if (isReservedAction(actionData.type)) {
        throw new Error('reserved action ' + actionData.type);
      }

      var _private = action._ || {}; // Dispatch actionStart
      // const autoPrefixType = `${actionData.type.replace(/Start$/, '')}Start`


      var dispatchData = _objectSpread2$1(_objectSpread2$1({}, actionData), {}, {
        _: _objectSpread2$1({
          originalAction: actionData.type
        }, _private) // type: `${autoPrefixType}`

      });

      store.dispatch(dispatchData);
    },
    // Do not use. Will be removed. Here for Backwards compatiblity.
    // Moved to analytics.plugins.enable
    enablePlugin: plugins.enable,
    /// Do not use. Will be removed. Here for Backwards compatiblity.
    /// Moved to analytics.plugins.disable
    disablePlugin: plugins.disable,
    // Do not use. Will be removed. Here for Backwards compatiblity.
    // New plugins api
    plugins: plugins,

    /**
     * Storage utilities for persisting data.
     * These methods will allow you to save data in localStorage, cookies, or to the window.
     * @typedef {Object} Storage
     * @property {GetItem} getItem - Get value from storage
     * @property {SetItem} setItem - Set storage value
     * @property {RemoveItem} removeItem - Remove storage value
     *
     * @example
     *
     * // Pull storage off analytics instance
     * const { storage } = analytics
     *
     * // Get value
     * storage.getItem('storage_key')
     *
     * // Set value
     * storage.setItem('storage_key', 'value')
     *
     * // Remove value
     * storage.removeItem('storage_key')
     */
    storage: {
      /**
       * Get value from storage
       * @typedef {Function} GetItem
       * @param {String} key - storage key
       * @param {Object} [options] - storage options
       * @return {Any}
       *
       * @example
       *
       * analytics.storage.getItem('storage_key')
       */
      getItem: storage.getItem,

      /**
       * Set storage value
       * @typedef {Function} SetItem
       * @param {String} key - storage key
       * @param {any} value - storage value
       * @param {Object} [options] - storage options
       *
       * @example
       *
       * analytics.storage.setItem('storage_key', 'value')
       */
      setItem: function setItem(key, value, options) {
        store.dispatch({
          type: EVENTS$1.setItemStart,
          key: key,
          value: value,
          options: options
        });
      },

      /**
       * Remove storage value
       * @typedef {Function} RemoveItem
       * @param {String} key - storage key
       * @param {Object} [options] - storage options
       *
       * @example
       *
       * analytics.storage.removeItem('storage_key')
       */
      removeItem: function removeItem(key, options) {
        store.dispatch({
          type: EVENTS$1.removeItemStart,
          key: key,
          options: options
        });
      }
    },

    /*
     * Set the anonymous ID of the visitor
     * @param {String} anonymousId - anonymous Id to set
     * @param {Object} [options] - storage options
     *
     * @example
     *
     * // Set anonymous ID
     * analytics.setAnonymousId('1234567')
     */
    setAnonymousId: function setAnonymousId(anonymousId, options) {
      /* sets temporary in memory id. Not to be relied on */
      // set(tempKey(ANONID), anonymousId)
      instance.storage.setItem(ANON_ID, anonymousId, options);
    },

    /*
     * Events exposed by core analytics library and all loaded plugins
     * @type {Array}
     */
    events: {
      all: allSystemEvents,
      core: coreEvents,
      plugins: allPluginEvents // byType: (type) => {} @Todo grab logic from engine and give inspectable events

    }
  };

  var enrichMiddleware = function enrichMiddleware(storeAPI) {
    return function (next) {
      return function (action) {
        if (!action.meta) {
          action.meta = generateMeta();
        }

        return next(action);
      };
    };
  };

  var middlewares = parsedOptions.middlewares.concat([enrichMiddleware,
  /* Core analytics middleware */
  dynamicMiddlewares(before), // Before dynamic middleware <-- fixed pageStart .on listener

  /* Plugin engine */
  pluginMiddleware(instance, getPlugins, {
    all: allSystemEvents,
    plugins: allPluginEvents
  }), storageMiddleware(storage), initializeMiddleware(instance), identifyMiddleware(instance),
  /* after dynamic middleware */
  dynamicMiddlewares(after)]);
  /* Initial analytics state keys */

  var coreReducers = {
    context: context,
    user: userReducer(storage),
    page: page,
    track: trackReducer,
    plugins: createReducer(getPlugins),
    queue: queueReducer
  };
  var composeEnhancers = compose;
  var composeWithGlobalDebug = compose;

  if (z && config.debug) {
    var devTools = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

    if (devTools) {
      composeEnhancers = devTools({
        trace: true,
        traceLimit: 25
      });
    }

    composeWithGlobalDebug = function composeWithGlobalDebug() {
      if (arguments.length === 0) return Debug();
      if (M(_typeof(arguments[0]))) return composeWithDebug();
      return composeWithDebug().apply(null, arguments);
    };
  }

  var initialConfig = makeContext(config);
  var intialPluginState = parsedOptions.pluginsArray.reduce(function (acc, plugin) {
    var name = plugin.name,
        config = plugin.config,
        loaded = plugin.loaded;
    var isEnabled = parsedOptions.pluginEnabled[name];
    acc[name] = {
      enabled: isEnabled,
      // If plugin enabled & has no initialize method, set initialized to true, else false
      initialized: isEnabled ? Boolean(!plugin.initialize) : false,
      loaded: Boolean(loaded()),
      config: config || {}
    };
    return acc;
  }, {});
  var initialState = {
    context: initialConfig,
    user: visitorInfo,
    plugins: intialPluginState // Todo allow for more userland defined initial state?

  };
  /* Create analytics store! */

  var store = createStore( // register reducers
  combineReducers(_objectSpread2$1(_objectSpread2$1({}, coreReducers), customReducers)), // set user defined initial state
  initialState, // register middleware & plugins used
  composeWithGlobalDebug(composeEnhancers(applyMiddleware.apply(void 0, _toConsumableArray(middlewares)))));
  /* Supe up dispatch with callback promise resolver. Happens in enrichMeta */

  function enhanceDispatch(fn) {
    return function (event, resolver, callbacks) {
      // console.log('original event', event)
      var meta = generateMeta(event.meta, resolver, ensureArray(callbacks)); // if (resolver) console.log('dispatch resolver', resolver)
      // if (callbacks) console.log('dispatch callbacks', callbacks)

      var newEvent = _objectSpread2$1(_objectSpread2$1({}, event), {
        meta: meta
      }); // console.log('newEvent', newEvent)


      return fn.apply(null, [newEvent]);
    };
  } // Automatically apply meta to dispatch calls


  store.dispatch = enhanceDispatch(store.dispatch);
  /* Synchronously call bootstrap & register Plugin methods */

  var pluginKeys = Object.keys(customPlugins);
  /* Bootstrap analytic plugins */

  store.dispatch({
    type: EVENTS$1.bootstrap,
    plugins: pluginKeys,
    config: initialConfig,
    params: params,
    user: visitorInfo,
    initialUser: initialUser,
    persistedUser: persistedUser
  });
  var enabledPlugins = pluginKeys.filter(function (name) {
    return parsedOptions.pluginEnabled[name];
  });
  var disabledPlugins = pluginKeys.filter(function (name) {
    return !parsedOptions.pluginEnabled[name];
  });
  /* Register analytic plugins */

  store.dispatch({
    type: EVENTS$1.registerPlugins,
    plugins: pluginKeys,
    enabled: parsedOptions.pluginEnabled
  });
  /* dispatch register for individual plugins */

  parsedOptions.pluginsArray.map(function (plugin, i) {
    var bootstrap = plugin.bootstrap,
        config = plugin.config,
        name = plugin.name;

    if (bootstrap && _(bootstrap)) {
      bootstrap({
        instance: instance,
        config: config,
        payload: plugin
      });
    }
    /* Register plugins */


    store.dispatch({
      type: EVENTS$1.registerPluginType(name),
      name: name,
      enabled: parsedOptions.pluginEnabled[name],
      plugin: plugin
    });
    /* All plugins registered initialize, is last loop */

    if (parsedOptions.pluginsArray.length === i + 1) {
      store.dispatch({
        type: EVENTS$1.initializeStart,
        plugins: enabledPlugins,
        disabled: disabledPlugins
      });
    }
  });

  {
    /* Watch for network events */
    watch(function (offline) {
      store.dispatch({
        type: offline ? EVENTS$1.offline : EVENTS$1.online
      });
    });
    /* Tick heartbeat for queued events */

    heartBeat(store, getPlugins, instance);
  }

  function appendArguments(fn) {
    return function () {
      /* Get original args */
      var args = Array.prototype.slice.call(arguments);
      /* Create clone of args */

      var newArgs = new Array(fn.length);

      for (var i = 0; i < args.length; i++) {
        newArgs[i] = args[i];
      }
      /* Append new arg to end */


      newArgs[newArgs.length] = instance; // Set instance on extended methods

      return fn.apply({
        instance: instance
      }, newArgs);
    };
  }
  /* Return analytics instance */


  return instance;
} // Duplicated strings


var before = 'before';
var after = 'after';

var t="cookie",i$1=a$1(),r$1=d$1,c=d$1;function u(o){return i$1?d$1(o,"",-1):i$2(o)}function a$1(){if(void 0!==i$1)return i$1;var e="cookiecookie";try{d$1(e,e),i$1=-1!==document.cookie.indexOf(e),u(e);}catch(e){i$1=!1;}return i$1}function d$1(e,t,r,c,u,a){if("undefined"!=typeof window){var d=arguments.length>1;return !1===i$1&&(d?f$1(e,t):a$2(e)),d?document.cookie=e+"="+encodeURIComponent(t)+(r?"; expires="+new Date(+new Date+1e3*r).toUTCString()+(c?"; path="+c:"")+(u?"; domain="+u:"")+(a?"; secure":""):""):decodeURIComponent((("; "+document.cookie).split("; "+e+"=")[1]||"").split(";")[0])}}

var r="localStorage",g=b$1.bind(null,"localStorage");u$1("localStorage","getItem",a$2);u$1("localStorage","setItem",f$1);u$1("localStorage","removeItem",i$2);

var a="sessionStorage",i=b$1.bind(null,"sessionStorage");u$1("sessionStorage","getItem",a$2);u$1("sessionStorage","setItem",f$1);u$1("sessionStorage","removeItem",i$2);

function I(t){var o=t;try{if("true"===(o=JSON.parse(t)))return !0;if("false"===o)return !1;if(M(o))return o;parseFloat(o)===o&&(o=parseFloat(o));}catch(t){}if(null!==o&&""!==o)return o}var k=g(),x=i(),C=a$1();function L(o,e){if(o){var r=A(e),a=!E(r),i=d(r)?I(localStorage.getItem(o)):void 0;if(a&&!$(i))return i;var s=h(r)?I(r$1(o)):void 0;if(a&&s)return s;var l=N(r)?I(sessionStorage.getItem(o)):void 0;if(a&&l)return l;var u=a$2(o);return a?u:{localStorage:i,sessionStorage:l,cookie:s,global:u}}}function O(r$2,a$1,l){if(r$2&&!$(a$1)){var u={},g=A(l),m=JSON.stringify(a$1),S=!E(g);return d(g)&&(u[r]=G(r,a$1,I(localStorage.getItem(r$2))),localStorage.setItem(r$2,m),S)?u[r]:h(g)&&(u[t]=G(t,a$1,I(r$1(r$2))),c(r$2,m),S)?u[t]:N(g)&&(u[a]=G(a,a$1,I(sessionStorage.getItem(r$2))),sessionStorage.setItem(r$2,m),S)?u[a]:(u[l$1]=G(l$1,a$1,a$2(r$2)),f$1(r$2,a$1),S?u[l$1]:u)}}function b(t$1,e){if(t$1){var a$1=A(e),n=L(t$1,l),s={};return !$(n.localStorage)&&d(a$1)&&(localStorage.removeItem(t$1),s[r]=n.localStorage),!$(n.cookie)&&h(a$1)&&(u(t$1),s[t]=n.cookie),!$(n.sessionStorage)&&N(a$1)&&(sessionStorage.removeItem(t$1),s[a]=n.sessionStorage),!$(n.global)&&F(a$1,l$1)&&(i$2(t$1),s[l$1]=n.global),s}}function A(t){return t?L$1(t)?t:t.storage:f}function d(t){return k&&F(t,r)}function h(t$1){return C&&F(t$1,t)}function N(t){return x&&F(t,a)}function E(t){return t===l||"all"===t}function F(t,o){return t===f||t===o||E(t)}function G(t,o,e){return {location:t,current:o,previous:e}}var J={setItem:O,getItem:L,removeItem:b};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function analyticsLib() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultSettings = {
    storage: J
  };
  return analytics$1(_objectSpread2(_objectSpread2({}, defaultSettings), opts));
}

const defaultConfig = {
    sendPageView: true,
    customDimensions: {},
    anonymizeIp: false,
    allowGoogleSignals: true,
    allowAdPersonalizationSignals: true,
};
let loadedInstances = {};
const googleGtagAnalytics = (pluginConfig = {}) => {
    let pageCalledOnce = false;
    // Allow for multiple google analytics instances
    const instanceName = pluginConfig.instanceName ? pluginConfig.instanceName : '';
    const trackingId = pluginConfig.trackingId;
    return {
        name: 'google-gtag-analytics',
        config: Object.assign(Object.assign({}, defaultConfig), pluginConfig),
        // Load gtag.js and define gtag
        // Set custom dimensions (ua properties) and parameters (ga4 properties)
        initialize: (pluginApi) => {
            const { config, instance } = pluginApi;
            if (!trackingId)
                throw new Error('No GA trackingId defined');
            const gtagScriptSource = 'https://www.googletagmanager.com/gtag/js';
            const scriptSrc = config.customScriptSrc || `${gtagScriptSource}?id=${trackingId}`;
            if (!gtagLoaded(config.customScriptSrc || gtagScriptSource)) {
                injectScript(scriptSrc);
            }
            if (!window.gtag) {
                setUpWindowGtag();
            }
            /**
             * Covert custom dimensions to:
             * { dimension1: traitOne, dimension2: traitTwo }
             */
            const customDimensions = formatCustomDimensionsIntoCustomMap(config);
            /**
             * Convert `cookieConfig`'s keys from camel case to snake cases
             */
            let newCookieConfig = {};
            if (config.cookieConfig !== undefined) {
                Object.entries(config.cookieConfig).forEach(([key, value]) => {
                    newCookieConfig[camelToSnakeCase(key)] = value;
                });
            }
            // Initialize tracker instance on page
            if (!loadedInstances[instanceName]) {
                let gtagConfig = Object.assign({ cookie_domain: config.domain || 'auto', send_page_view: config.sendPageView ? config.sendPageView : true, allow_google_signals: config.allowGoogleSignals, allow_ad_personalization_signals: config.allowAdPersonalizationSignals, custom_map: customDimensions, anonymize_ip: config.anonymizeIp }, newCookieConfig);
                if (config.linker) {
                    gtagConfig.linker = config.linker;
                }
                /* set custom dimensions from user traits */
                const user = instance.user() || {};
                const traits = user.traits || {};
                if (Object.keys(traits).length) {
                    window.gtag('set', traits);
                }
                window.gtag('config', trackingId, gtagConfig);
                loadedInstances[instanceName] = true;
            }
        },
        // Set parameter scope at user level with 'set' method
        identify: (props) => {
            const { payload, config } = props;
            identifyVisitor(payload.userId, payload.traits, config);
        },
        // Set parameter scope at page level with 'config' method
        page: ({ payload, config, instance }) => {
            if (!window.gtag || !config.trackingId)
                return;
            const { properties } = payload;
            const { resetCustomDimensionsOnPage, customDimensions } = config;
            const campaign = instance.getState('context.campaign');
            /* If dimensions are specified to reset, clear them before page view */
            if (resetCustomDimensionsOnPage && resetCustomDimensionsOnPage.length && customDimensions) {
                const resetDimensions = resetCustomDimensionsOnPage.reduce((acc, key) => {
                    if (customDimensions[key]) {
                        acc[key] = null; // { 'dimension_name': null } etc
                    }
                    return acc;
                }, {});
                if (Object.keys(resetDimensions).length) {
                    // Reset custom dimensions
                    window.gtag('set', resetDimensions);
                }
            }
            /**
             * Create pageview-related properties
             */
            const path = properties.path || document.location.pathname;
            const pageView = {
                page_path: path,
                page_title: properties.title,
                page_location: properties.url,
            };
            const campaignData = addCampaignData(campaign);
            /**
             * Creates property dimensions for global scope
             */
            const globalProperties = getProperties(properties, config.globalProperties);
            const pageData = Object.assign({ page: path, title: properties.title, 
                // allow referrer override if referrer was manually set
                referrer: properties.referrer !== document.referrer ? properties.referrer : undefined }, globalProperties);
            window.gtag('set', pageData);
            /* Set dimensions or return them for `config` if config.setCustomDimensionsToPage is false */
            const customDimensionValues = setCustomDimensions(properties, config);
            /**
             * Creates property dimensions for user scope
             */
            const userProperties = getProperties(properties, config.userProperties);
            const convertedCustomDimensions = formatCustomDimensionsIntoCustomMap(config);
            /* Dimensions will only be included in the event if config.setCustomDimensionsToPage is false */
            window.gtag('config', config.trackingId, Object.assign({ 
                // Every time a `pageview` is sent, we need to pass custom_map again into the configuration
                custom_map: convertedCustomDimensions, send_page_view: config.sendPageView || true }, userProperties));
            /**
             * Create user properties for `config` method that are not part of custom dimensions
             */
            const pageRelatedProperties = ['title', 'url', 'path', 'sendPageView', 'referrer'];
            const customDimensionKeys = (customDimensions && Object.keys(customDimensions)) || [];
            const selfDefinedPageProperties = Object.keys(properties).reduce((acc, key) => {
                if (!pageRelatedProperties.includes(key) && !customDimensionKeys.includes(key) && !(config.globalProperties && config.globalProperties.includes(key)) && !(config.userProperties && config.userProperties.includes(key))) {
                    acc[key] = properties[key];
                }
                return acc;
            }, {});
            /* Dimensions will only be included in the event if config.setCustomDimensionsToPage is false */
            const finalPayload = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ send_to: config.trackingId }, pageView), campaignData), customDimensionValues), pageRelatedProperties), selfDefinedPageProperties);
            // Remove location for SPA tracking after initial page view
            if (pageCalledOnce) {
                delete finalPayload.page_location;
            }
            window.gtag('event', 'page_view', finalPayload);
            // Set after initial page view
            pageCalledOnce = true;
        },
        loaded: () => {
            return Boolean(window.gtag);
        },
        // Set parameter scope at event level with 'event' method
        track: ({ payload, config, instance }) => {
            const { properties, event } = payload;
            const { label, value, category, nonInteraction } = properties;
            const campaign = instance.getState('context.campaign');
            trackEvent({
                event,
                label,
                category: category || 'All',
                value,
                nonInteraction,
                campaign,
            }, config, payload);
        },
    };
};
const trackEvent = (eventData, config = {}, payload) => {
    if (!window.gtag || !config.trackingId)
        return;
    /* Set Dimensions or return them for payload if config.setCustomDimensionsToPage is false */
    const customDimensionValues = setCustomDimensions(payload.properties, config);
    const convertedCustomDimensions = formatCustomDimensionsIntoCustomMap(config);
    /**
     * You have to re`config` custom_map for events if new values are `set` for a user
     */
    window.gtag('config', config.trackingId, {
        send_page_view: config.sendPageView || true,
        custom_map: convertedCustomDimensions,
    });
    /**
     * Create event-related properties
     */
    const data = {
        event_label: eventData.label,
        event_category: eventData.category || 'All',
        non_interaction: (eventData.nonInteraction !== undefined) ? Boolean(eventData.nonInteraction) : false,
    };
    if (eventData.value) {
        /* set value of the action */
        data.value = eventData.value >= 0 ? eventData.value : 0;
    }
    /* Attach campaign data */
    const campaignData = addCampaignData(eventData.campaign);
    /**
     * Creates self-defined event property values
     */
    const gaEventProperties = ['label', 'category', 'nonInteraction', 'value'];
    const selfDefinedEventProperties = Object.keys(payload.properties).reduce((acc, key) => {
        if (!gaEventProperties.includes(key)) {
            acc[key] = payload.properties[key];
        }
        return acc;
    }, {});
    const finalPayload = Object.assign(Object.assign(Object.assign(Object.assign({}, data), campaignData), customDimensionValues), selfDefinedEventProperties);
    /* Send data to Google Analytics */
    window.gtag('event', eventData.event, finalPayload);
    return finalPayload;
};
const camelToSnakeCase = (key) => key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
const get = (obj, key) => {
    const keys = key.split ? key.split('.') : key;
    let object = undefined;
    for (let p = 0; p < keys.length; p++) {
        object = obj ? obj[keys[p]] : undefined;
    }
    return object;
};
/**
 * Add campaign data to GA payload https://bit.ly/34qFCPn
 * @param {Object} [campaignData={}] [description]
 * @param {String} [campaignData.campaignName] - Name of campaign
 * @param {String} [campaignData.campaignSource] - Source of campaign
 * @param {String} [campaignData.campaignMedium] - Medium of campaign
 * @param {String} [campaignData.campaignContent] - Content of campaign
 * @param {String} [campaignData.campaignKeyword] - Keyword of campaign
 */
function addCampaignData(campaignData = {}) {
    let campaign = {};
    const { name, source, medium, content, keyword } = campaignData;
    if (name)
        campaign.campaignName = name;
    if (source)
        campaign.campaignSource = source;
    if (medium)
        campaign.campaignMedium = medium;
    if (content)
        campaign.campaignContent = content;
    if (keyword)
        campaign.campaignKeyword = keyword;
    return campaign;
}
/**
 * Changes format of custom dimensions from:
 * { traitOne: 'dimension1', traitTwo: 'dimension2' }
 * to:
 * { dimension1: traitOne, dimension2: traitTwo }
 */
const formatCustomDimensionsIntoCustomMap = (plugin) => {
    const { customDimensions } = plugin;
    return customDimensions && Object.entries(customDimensions).reduce((acc, entry) => {
        const [key, value] = entry;
        acc[value] = key;
        return acc;
    }, {});
};
/**
 * Create parameter value object based on given key values.
 * */
const getProperties = (properties = {}, propertyKeys = []) => {
    return propertyKeys.reduce((acc, key) => {
        if (properties[key]) {
            acc[key] = properties[key];
        }
        return acc;
    }, {});
};
/**
 * Create custom dimension value object with keys that exist in
 * config.customDimensions. If `config.setCustomDimensionsToPage`
 * is true, set custom dimension values with the `set` command.
 * Otherwise, return object for `config`.
 * */
const setCustomDimensions = (properties = {}, config) => {
    const { customDimensions } = config;
    if (!customDimensions)
        return {};
    const customDimensionsValue = Object.keys(customDimensions).reduce((acc, key) => {
        let value = get(properties, key) || properties[key];
        if (typeof value === 'boolean') {
            value = value.toString();
        }
        if (value || value === 0) {
            acc[key] = value;
            return acc;
        }
        return acc;
    }, {});
    if (!Object.keys(customDimensionsValue).length)
        return {};
    if (!config.setCustomDimensionsToPage) {
        return customDimensionsValue;
    }
    window.gtag('set', customDimensionsValue);
    return {};
};
const identifyVisitor = (id, traits = {}, config = {}) => {
    const trackingId = config.trackingId;
    if (!window.gtag || !trackingId)
        return;
    if (id) {
        window.gtag('set', { user_id: id });
    }
    if (Object.keys(traits).length) {
        window.gtag('set', traits);
    }
};
const gtagLoaded = (scriptSrc) => {
    return scriptLoaded(scriptSrc);
};
const scriptLoaded = (scriptSrc) => {
    const scripts = document.querySelectorAll('script[src]');
    const regex = new RegExp(`^${scriptSrc}`);
    return Boolean(Object.values(scripts).filter((value) => regex.test(value.src)).length);
};
const injectScript = (scriptSrc) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.body.appendChild(script);
    return script;
};
const setUpWindowGtag = () => {
    window.dataLayer = window.dataLayer || [];
    function gtagHelper() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
    }
    gtagHelper('js', new Date());
    window.gtag = gtagHelper;
    return gtagHelper;
};

const analytics = (config) => analyticsLib({
    app: config.app,
    debug: config.debug || false,
    plugins: [
        googleGtagAnalytics({
            trackingId: config.trackingId,
        }),
    ],
});

const setupAnalyticsWorkflow = (component, config) => {
    const workflow = component.element.querySelector('[ga-workflow]');
    getAnalyticsService(config.trackingId, config.app).setWorkflow({
        id: workflow.getAttribute('ga-workflow-id'),
        name: workflow.getAttribute('ga-workflow'),
        order: workflow.getAttribute('ga-workflow-order'),
    });
    const workflowElement = component.element.querySelector('[ga-workflow-element]');
    getAnalyticsService(config.trackingId, config.app).setWorkflowElement({
        id: workflowElement.getAttribute('ga-workflow-element-id'),
        name: workflowElement.getAttribute('ga-workflow-element'),
        order: workflowElement.getAttribute('ga-workflow-element-order'),
    });
    const moduleData = getModuleData(component.element);
    getAnalyticsService(config.trackingId, config.app).setModule(moduleData);
};
const getModuleData = (element) => {
    const module = closestParent(element, 'ga-module');
    if (module) {
        return {
            id: module.getAttribute('ga-module-id'),
            name: module.getAttribute('ga-module'),
            order: module.getAttribute('ga-module-order'),
        };
    }
    return { id: null, name: null, order: null };
};
// Could be moved to a more general helper
const closestParent = (element, attribute) => {
    while (element && element.tagName !== 'BODY') {
        if (element.parentNode.hasAttribute(attribute))
            return element.parentNode;
        element = element.parentNode;
    }
    return null;
};

var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType["VIEW"] = "VIEW";
    AnalyticsEventType["MANAGE"] = "MANAGE";
    AnalyticsEventType["SEARCH"] = "SEARCH";
    AnalyticsEventType["CHAT"] = "CHAT";
    AnalyticsEventType["LOGIN"] = "LOGIN";
    AnalyticsEventType["LOGOUT"] = "LOGOUT";
    AnalyticsEventType["ERROR"] = "ERROR";
    AnalyticsEventType["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    AnalyticsEventType["INCREMENT"] = "INCREMENT";
    AnalyticsEventType["DECREMENT"] = "DECREMENT";
    AnalyticsEventType["SLIDER"] = "SLIDER";
    AnalyticsEventType["CANCEL"] = "CANCEL";
    AnalyticsEventType["SAVE"] = "SAVE";
    AnalyticsEventType["DELETE"] = "DELETE";
    AnalyticsEventType["CREATE"] = "CREATE";
    AnalyticsEventType["NEW"] = "NEW";
    AnalyticsEventType["EDIT"] = "EDIT";
    AnalyticsEventType["NAVIGATE"] = "NAVIGATE";
})(AnalyticsEventType || (AnalyticsEventType = {}));

class AnalyticsService {
    constructor(config) {
        this.trackPageView = () => analytics({ trackingId: this.trackingId, app: this.app }).page();
        this.initAnalytics = (trackingId) => this.trackingId = trackingId;
        this.identifyUser = (user) => {
            const { id } = user;
            analytics({ trackingId: this.trackingId, app: this.app }).identify(id, Object.assign({}, lodash.omit(user, 'id')));
        };
        this.setupBasicTracking = (user) => {
            this.identifyUser(user);
            this.trackPageView();
        };
        this.trackEvent = (eventType, eventData) => {
            const { user } = this.getAnalyticsState();
            const eventPayload = this.buildEventPayload(user, eventData);
            const stringifiedPayload = lodash.reduce(eventPayload, (r, v, k) => {
                r[k] = JSON.stringify(v);
                return r;
            }, {});
            analytics({ trackingId: this.trackingId, app: this.app }).track(eventType, stringifiedPayload);
        };
        //Factory methods
        this.buildEventPayload = (user, eventData) => {
            const { id } = user.traits;
            return {
                customerData: { id },
                app: this.buildAppData(),
                context: this.buildContextData(),
                event: eventData,
                workflow: this.buildWorkflowData(),
                workflowElement: this.buildWorkflowElementData(),
                module: this.buildModuleData(),
            };
        };
        this.buildAppData = () => {
            const { app, userAgent, os, referrer, timeZone, offline } = this.getAnalyticsState().context;
            return {
                app,
                url: getBaseUrl(),
                userAgent,
                deviceInformation: os.name,
                referrer,
                miscData: { timeZone, offline },
            };
        };
        this.buildContextData = () => this.getItemFromStore('context');
        this.buildWorkflowData = () => this.getItemFromStore('workflow');
        this.buildWorkflowElementData = () => this.getItemFromStore('workflowElement');
        this.buildModuleData = () => this.getItemFromStore('module');
        //Analytics Store functions
        this.setWorkflow = (data) => this.setItemInStore('workflow', data);
        this.setWorkflowElement = (data) => this.setItemInStore('workflowElement', data);
        this.setModule = (data) => this.setItemInStore('module', data);
        this.setContext = (data) => this.setItemInStore('context', data);
        //Analytics State functions
        this.getAnalyticsState = () => analytics({ trackingId: this.trackingId, app: this.app }).getState();
        this.getItemFromStore = (key) => analytics({ trackingId: this.trackingId, app: this.app }).storage.getItem(key);
        this.setItemInStore = (key, value) => analytics({ trackingId: this.trackingId, app: this.app }).storage.setItem(key, value);
        this.trackingId = config.trackingId;
        this.app = config.app;
    }
}
const getAnalyticsService = (trackingId, app) => new AnalyticsService({ trackingId, app });

class FusionDataStore extends MoDataStore {
    constructor(config) {
        super(config);
    }
    /**
     * @override
     */
    processConfig() {
        this.defaultParamsList = ['service', 'idProp', 'crossApp'];
        this.apiConfig.crossApp = this.config.crossApp;
        super.processConfig();
    }
}

class AppsStoreMockPlugin extends DataStoreMockPlugin {
    constructor() {
        super(...arguments);
        this.mockApis = ['getCurrentApp', ...DataStoreMockPlugin.crudMockApis];
    }
    /**
     * @override
     */
    async getMockData() {
        var _a;
        (_a = this.mocks) !== null && _a !== void 0 ? _a : (this.mocks = await import('./apps-store-mock-data-2f20ddcd.js'));
        return this.mocks.data;
    }
    getCurrentApp() {
        return this.mocks.currentApp;
    }
}

class AppsStore extends FusionDataStore {
    getCurrentApp() {
        const storeApiService = getStoreApiService();
        return storeApiService.getAppId();
    }
}
AppsStore.defaultConfig = {
    mockPlugin: AppsStoreMockPlugin,
    api: {
        service: 'apps',
        list: 'getAllEntities',
        get: 'getEntity',
    },
};

const IntrospectApiData = {
	"apps::v1": {
	name: "com.lucidworks.apollo.resources.AppResource",
	uri: "/apps",
	methods: [
		{
			uri: "/apps",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}/{service}/{path:.*}",
			name: "doGetProxyWithPath",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}/{service}/{path:.*}",
			name: "doPutProxyWithPath",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}/{service}/{path:.*}",
			name: "doHeadProxyWithPath",
			verb: "HEAD",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}/{service}/{path:.*}",
			name: "doDeleteProxyWithPath",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}/{service}/{path:.*}",
			name: "doPostProxyWithPath",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}/{service}",
			name: "doPutProxy",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}/{service}",
			name: "doGetProxy",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}/{service}",
			name: "doHeadProxy",
			verb: "HEAD",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}/{service}",
			name: "doPostProxy",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}/{service}",
			name: "doDeleteProxy",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "service",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/apps/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/apps/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"blobs::v1": {
	name: "com.lucidworks.apollo.resources.BlobResource",
	uri: "/blobs",
	methods: [
		{
			uri: "/blobs",
			name: "listBlobManifests",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "dir",
					type: "String"
				},
				{
					name: "recurse",
					type: "Boolean"
				},
				{
					name: "showdirs",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/blobs/{id:.*}",
			name: "getBlob",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/blobs/{id:.*}",
			name: "deleteFile",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "commit",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/blobs/{id:.*}",
			name: "getBlobMetadata",
			verb: "HEAD",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/blobs/{id:.*}",
			name: "putBlob",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "commit",
					type: "boolean"
				},
				{
					name: "update",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/blobs/convert",
			name: "migrateBlobManifests",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/blobs/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"collections::v1": {
	name: "com.lucidworks.apollo.resources.CollectionResource",
	uri: "/collections",
	methods: [
		{
			uri: "/collections",
			name: "createCollection",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "pipelines",
					type: "Boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/collections",
			name: "getCollections",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}",
			name: "deleteCollection",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "solr",
					type: "Boolean"
				},
				{
					name: "purge",
					type: "Boolean"
				},
				{
					name: "pipelines",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}",
			name: "overwriteCollection",
			verb: "PUT",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}",
			name: "getCollection",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/features/{feature}",
			name: "overwriteFeature",
			verb: "PUT",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "feature",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "callback",
					type: "Boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}/features/{feature}",
			name: "resetFeature",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "feature",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "callback",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/features/{feature}",
			name: "getFeature",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "feature",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/features",
			name: "listFeatures",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/status",
			name: "getCollectionStatus",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/stats",
			name: "getCollectionMetrics",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"connectors-classic::v1": {
	name: "com.lucidworks.resources.ConnectorsResourceV3",
	uri: "/connectors-classic",
	methods: [
		{
			uri: "/connectors-classic",
			name: "getConnectorTypes0",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/state",
			name: "reset",
			verb: "PUT",
			pathParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/usage",
			name: "getUsageNumbers",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connectorName}/source",
			name: "installOrUpdatePlugin",
			verb: "PUT",
			pathParams: [
				{
					name: "connectorName",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connectorName}/source",
			name: "uninstallPlugin",
			verb: "DELETE",
			pathParams: [
				{
					name: "connectorName",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}",
			name: "getConnectorSpecs0",
			verb: "GET",
			pathParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}",
			name: "setClosing",
			verb: "PUT",
			pathParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "close",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/sample",
			name: "datasourceDocsSample",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "limit",
					type: "Integer"
				},
				{
					name: "wait",
					type: "Integer"
				},
				{
					name: "refresh",
					type: "Boolean"
				},
				{
					name: "maxFieldLength",
					type: "Integer"
				},
				{
					name: "excludeBinaryFields",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/sample/pipeline-debug",
			name: "datasourceDocsSamplePipelineDebug",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "limit",
					type: "Integer"
				},
				{
					name: "wait",
					type: "Integer"
				},
				{
					name: "refresh",
					type: "Boolean"
				},
				{
					name: "maxFieldLength",
					type: "Integer"
				},
				{
					name: "excludeBinaryFields",
					type: "Boolean"
				},
				{
					name: "pipelineId",
					type: "String"
				},
				{
					name: "parserId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db",
			name: "getDb",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db",
			name: "dropDb",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "remove_output",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/security_filter/{collection}",
			name: "buildSecurityFilterFromSubject",
			verb: "POST",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "datasources",
					type: "List"
				}
			],
			hasEntity: true
		},
		{
			uri: "/connectors-classic/security_filter/{collection}",
			name: "buildSecurityFilter",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "username",
					type: "String"
				},
				{
					name: "datasources",
					type: "List"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/suggestions/datasources",
			name: "suggestDataSourceConfig",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "input",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/resources/{name}",
			name: "uploadResource",
			verb: "POST",
			pathParams: [
				{
					name: "connector",
					type: "String"
				},
				{
					name: "name",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "id",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/connectors-classic/plugins/{connector}/resources/{name}",
			name: "deleteResource",
			verb: "DELETE",
			pathParams: [
				{
					name: "connector",
					type: "String"
				},
				{
					name: "name",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "id",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/resources/{name}",
			name: "openResource",
			verb: "GET",
			pathParams: [
				{
					name: "connector",
					type: "String"
				},
				{
					name: "name",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "id",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db/{table}/items/{item}",
			name: "deleteItem",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "table",
					type: "String"
				},
				{
					name: "item",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db/{table}/items/{item}",
			name: "getItem",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "table",
					type: "String"
				},
				{
					name: "item",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources",
			name: "addDataSource",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "validate",
					type: "boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/connectors-classic/datasources",
			name: "getDataSources",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources",
			name: "removeDataSources",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "force",
					type: "boolean"
				},
				{
					name: "remove_output",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}",
			name: "getDataSource",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}",
			name: "removeDataSource",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "force",
					type: "boolean"
				},
				{
					name: "remove_output",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}",
			name: "updateDataSource",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "validate",
					type: "boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/connectors-classic/plugins",
			name: "getConnectorTypes",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/pluginsByCategory",
			name: "getConnectorTypesByCategory",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/types",
			name: "getConnectorSchemaTypes",
			verb: "GET",
			pathParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/types/{type}",
			name: "getConnectorSchemaType",
			verb: "GET",
			pathParams: [
				{
					name: "connector",
					type: "String"
				},
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs/{id}",
			name: "startJob",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs/{id}",
			name: "stopJob",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "abort",
					type: "boolean"
				},
				{
					name: "wait_time",
					type: "long"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs/{id}",
			name: "getJobStatus",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs",
			name: "listJobs",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs",
			name: "finishAllJobs",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
				{
					name: "connector",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				},
				{
					name: "abort",
					type: "boolean"
				},
				{
					name: "wait_time",
					type: "long"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/jobs/{id}/pipeline",
			name: "getPipelineStats",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/output",
			name: "deleteOutputData",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/validation",
			name: "validateDataSource",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
				{
					name: "remove_unknown_props",
					type: "boolean"
				},
				{
					name: "verify_access",
					type: "boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/connectors-classic/history/{id}",
			name: "getHistory",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "cumulative",
					type: "boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/history/{id}",
			name: "removeHistory",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/getDirectoryItems",
			name: "getDirectoryItems",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "pageStart",
					type: "String"
				},
				{
					name: "limit",
					type: "Integer"
				},
				{
					name: "maxWaitTimeMs",
					type: "Integer"
				},
				{
					name: "path",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db/{table}",
			name: "getTableStats",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "table",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db/{table}",
			name: "dropTable",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "table",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/service/status",
			name: "createServiceStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/plugins/{connector}/resources",
			name: "listResources",
			verb: "GET",
			pathParams: [
				{
					name: "connector",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "id",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/datasources/{id}/db/{table}/items",
			name: "getItems",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "table",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "start",
					type: "String"
				},
				{
					name: "rows",
					type: "int"
				}
			],
			hasEntity: false
		},
		{
			uri: "/connectors-classic/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"experiments::v1": {
	name: "com.lucidworks.apollo.resources.ExperimentResource",
	uri: "/experiments",
	methods: [
		{
			uri: "/experiments",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/experiments/{id}/variant",
			name: "getVariant",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "userId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/job",
			name: "startJob",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/job",
			name: "stopJob",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/history",
			name: "getHistory",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/metrics",
			name: "recompute",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "sync",
					type: "Boolean"
				},
				{
					name: "syncWaitSeconds",
					type: "Integer"
				}
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/metrics",
			name: "getMetrics",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/metrics/{runId}",
			name: "getMetricsForRun",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "runId",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/groundTruth",
			name: "getGroundTruthResultsAsJson",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "queryLimit",
					type: "int"
				},
				{
					name: "docLimit",
					type: "int"
				}
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}/groundTruth",
			name: "getGroundTruthResultsAsCsv",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "queryLimit",
					type: "int"
				},
				{
					name: "docLimit",
					type: "int"
				}
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/experiments/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/experiments/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"features::v1": {
	name: "com.lucidworks.apollo.resources.FeatureResource",
	uri: "/features",
	methods: [
		{
			uri: "/features",
			name: "listFeatures",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/features/{feature}",
			name: "getFeature",
			verb: "GET",
			pathParams: [
				{
					name: "feature",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/features/{feature}/_schema",
			name: "getFeatureSchema",
			verb: "GET",
			pathParams: [
				{
					name: "feature",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/features/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"index-pipelines::v1": {
	name: "com.lucidworks.apollo.resources.IndexPipelineResource",
	uri: "/index-pipelines",
	methods: [
		{
			uri: "/index-pipelines",
			name: "listPipelines",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines",
			name: "createPipeline",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/index",
			name: "index",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "stats",
					type: "Boolean"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "eventsCollection",
					type: "String"
				},
				{
					name: "eventsPipeline",
					type: "String"
				},
				{
					name: "eventTypes",
					type: "String"
				},
				{
					name: "stageId",
					type: "String"
				},
				{
					name: "parserId",
					type: "String"
				},
				{
					name: "skipParsing",
					type: "Boolean"
				},
				{
					name: "autoDetectFormat",
					type: "Boolean"
				},
				{
					name: "contentSourceName",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/index",
			name: "indexPipelineDocument",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "stats",
					type: "Boolean"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "eventsCollection",
					type: "String"
				},
				{
					name: "eventsPipeline",
					type: "String"
				},
				{
					name: "eventTypes",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/index",
			name: "indexPipelineDocumentNoStats",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "eventsCollection",
					type: "String"
				},
				{
					name: "eventsPipeline",
					type: "String"
				},
				{
					name: "eventTypes",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/index",
			name: "indexNoStats",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "eventsCollection",
					type: "String"
				},
				{
					name: "eventsPipeline",
					type: "String"
				},
				{
					name: "eventTypes",
					type: "String"
				},
				{
					name: "stageId",
					type: "String"
				},
				{
					name: "parserId",
					type: "String"
				},
				{
					name: "skipParsing",
					type: "Boolean"
				},
				{
					name: "autoDetectFormat",
					type: "Boolean"
				},
				{
					name: "contentSourceName",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/metrics",
			name: "getPipelineMetrics",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "pretty",
					type: "Boolean"
				},
				{
					name: "rateUnit",
					type: "String"
				},
				{
					name: "durationUnit",
					type: "String"
				},
				{
					name: "showSamples",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/debug",
			name: "debugPipelineDocument",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "eventsCollection",
					type: "String"
				},
				{
					name: "eventsPipeline",
					type: "String"
				},
				{
					name: "eventTypes",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/reindex",
			name: "reIndex",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "throwOnError",
					type: "Boolean"
				},
				{
					name: "parserId",
					type: "String"
				},
				{
					name: "skipParsing",
					type: "Boolean"
				},
				{
					name: "autoDetectFormat",
					type: "Boolean"
				},
				{
					name: "contentSourceName",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/collections/{collection}/indexMultiple",
			name: "indexMultiple",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}/refresh",
			name: "stopPipeline",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines/{id}/refresh",
			name: "refreshPipeline",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines/{id}",
			name: "deletePipeline",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines/{id}",
			name: "createOrUpdatePipeline",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/index-pipelines/{id}",
			name: "getPipeline",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-pipelines/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"index-profiles-crud::v1": {
	name: "com.lucidworks.apollo.resources.IndexProfileCRUDResource",
	uri: "/index-profiles",
	methods: [
		{
			uri: "/index-profiles",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-profiles",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/index-profiles/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-profiles/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/index-profiles/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-profiles/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/index-profiles/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"index-profiles::v1": {
	name: "com.lucidworks.apollo.resources.IndexProfileResource",
	uri: "/index",
	methods: [
		{
			uri: "/index/{id}",
			name: "index",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "stats",
					type: "Boolean"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				},
				{
					name: "contentSourceName",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index/{id}",
			name: "indexPipelineDocument",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "stats",
					type: "Boolean"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/index/{id}/debug",
			name: "debug",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "simulate",
					type: "Boolean"
				},
				{
					name: "echo",
					type: "Boolean"
				},
				{
					name: "echoMaxCount",
					type: "Integer"
				},
				{
					name: "bufferDocsForSolr",
					type: "Boolean"
				}
			],
			hasEntity: true
		}
	]
},
	"jobs::v1": {
	name: "com.lucidworks.apollo.resources.JobResource",
	uri: "/jobs",
	methods: [
		{
			uri: "/jobs",
			name: "listJobs",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "status",
					type: "List"
				},
				{
					name: "enabled",
					type: "String"
				},
				{
					name: "type",
					type: "List"
				}
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}",
			name: "getJob",
			verb: "GET",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}/schedule",
			name: "resetJobConfig",
			verb: "DELETE",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}/schedule",
			name: "getJobConfig",
			verb: "GET",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}/schedule",
			name: "setJobConfig",
			verb: "PUT",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/_schema",
			name: "getJobConfigSchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}/actions",
			name: "controlJob",
			verb: "POST",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/jobs/{resource}/history",
			name: "listJobHistory",
			verb: "GET",
			pathParams: [
				{
					name: "resource",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "limit",
					type: "int"
				}
			],
			hasEntity: false
		},
		{
			uri: "/jobs/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"license::v1": {
	name: "com.lucidworks.apollo.resources.LicenseResource",
	uri: "/license",
	methods: [
		{
			uri: "/license",
			name: "exportLicense",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license",
			name: "replaceLicense",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/license",
			name: "replaceLicense",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/license",
			name: "getLicense",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license/capability/{capability}",
			name: "getCapability",
			verb: "GET",
			pathParams: [
				{
					name: "capability",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license/expiration",
			name: "getExpirationDate",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license/check",
			name: "checkLicense",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license/cache",
			name: "clearCache",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/license/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"parsers::v1": {
	name: "com.lucidworks.apollo.resources.ParserResource",
	uri: "/parsers",
	methods: [
		{
			uri: "/parsers",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/parsers",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/parsers/{id}/parse",
			name: "parseFileForm",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "limit",
					type: "Integer"
				},
				{
					name: "offset",
					type: "Integer"
				}
			],
			hasEntity: true
		},
		{
			uri: "/parsers/{id}/parse",
			name: "parseFileDirect",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "limit",
					type: "Integer"
				},
				{
					name: "offset",
					type: "Integer"
				}
			],
			hasEntity: true
		},
		{
			uri: "/parsers/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/parsers/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/parsers/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/parsers/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/parsers/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"query-pipelines::v1": {
	name: "com.lucidworks.apollo.resources.QueryPipelineResource",
	uri: "/query-pipelines",
	methods: [
		{
			uri: "/query-pipelines",
			name: "listPipelines",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines",
			name: "createPipeline",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-pipelines/{id}/collections/{collection}/{handler}",
			name: "query",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				},
				{
					name: "handler",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/{id}/collections/{collection}/{handler}",
			name: "queryWithPost",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				},
				{
					name: "handler",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-pipelines/{id}/collections/{collection}/{handler}",
			name: "queryWithJSON",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				},
				{
					name: "handler",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-pipelines/{id}/collections/{collection}/{handler}",
			name: "queryWithAudio",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "collection",
					type: "String"
				},
				{
					name: "handler",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-pipelines/{id}/metrics",
			name: "getPipelineMetrics",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "pretty",
					type: "Boolean"
				},
				{
					name: "rateUnit",
					type: "String"
				},
				{
					name: "durationUnit",
					type: "String"
				},
				{
					name: "showSamples",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/{id}",
			name: "deletePipeline",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/{id}",
			name: "createOrUpdatePipeline",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-pipelines/{id}",
			name: "getPipeline",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/{id}/refresh",
			name: "refreshPipeline",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/{id}/refresh",
			name: "stopPipeline",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-pipelines/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"query-profiles-crud::v1": {
	name: "com.lucidworks.apollo.resources.QueryProfileCRUDResource",
	uri: "/query-profiles",
	methods: [
		{
			uri: "/query-profiles",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-profiles",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-profiles/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-profiles/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query-profiles/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-profiles/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query-profiles/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"query-profiles::v1": {
	name: "com.lucidworks.apollo.resources.QueryProfileResource",
	uri: "/query",
	methods: [
		{
			uri: "/query/{id:.*}",
			name: "query",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query/{id:.*}",
			name: "queryWithPost",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query/{id:.*[/]}",
			name: "queryWithPostSolrj",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/query/{id:.*[/]}",
			name: "querySolrj",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/query/{id}/signals",
			name: "submitSignal",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "pipeline",
					type: "String"
				},
				{
					name: "commit",
					type: "boolean"
				},
				{
					name: "async",
					type: "Boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query/{id}/signals",
			name: "submitSignalsAsPipelineDocuments",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "pipeline",
					type: "String"
				},
				{
					name: "commit",
					type: "boolean"
				},
				{
					name: "async",
					type: "Boolean"
				}
			],
			hasEntity: true
		}
	]
},
	"query-rewrite::v1": {
	name: "com.lucidworks.apollo.resources.QueryRewriteResource",
	uri: "/query-rewrite",
	methods: [
		{
			uri: "/query-rewrite/instances",
			name: "create",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/instances",
			name: "list",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/instances",
			name: "doBulkOperation",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/search",
			name: "searchAll",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/search/{type}",
			name: "search",
			verb: "GET",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/publish",
			name: "rollbackAll",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/search/targeted-docs",
			name: "getRelatedRules",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				},
				{
					name: "docId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/publish",
			name: "publishAll",
			verb: "PUT",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/publish/{type}",
			name: "rollback",
			verb: "DELETE",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/publish/{type}",
			name: "publish",
			verb: "PUT",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/instances/{id}/publish",
			name: "publishRule",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/undo/{id}",
			name: "rollback",
			verb: "DELETE",
			pathParams: [
				{
					name: "id"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/schema",
			name: "createCustomType",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/schema",
			name: "getSchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/schema/{type}",
			name: "updateCustomType",
			verb: "PUT",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/schema/{type}",
			name: "deleteCustomType",
			verb: "DELETE",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/schema/{type}",
			name: "getSchema",
			verb: "GET",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/{type}",
			name: "getQueryRewriteTypeStatus",
			verb: "GET",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/{type}",
			name: "updateQueryRewriteTypeEnabled",
			verb: "PUT",
			pathParams: [
				{
					name: "type",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/instances/{id}",
			name: "getQueryRewrite",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/instances/{id}",
			name: "deleteQueryRewrite",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/query-rewrite/instances/{id}",
			name: "updateQueryRewrite",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "context",
					type: "String"
				},
				{
					name: "editSessionId",
					type: "String"
				}
			],
			hasEntity: true
		},
		{
			uri: "/query-rewrite/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"schema::v1": {
	name: "com.lucidworks.apollo.resources.SchemaResource",
	uri: "/collections/{collection}/schema",
	methods: [
		{
			uri: "/collections/{collection}/schema/fields",
			name: "getFields",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/fields",
			name: "addField",
			verb: "POST",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}/schema/dynamicfields",
			name: "addDynamicField",
			verb: "POST",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}/schema/dynamicfields",
			name: "getDynamicFields",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/fields.schema",
			name: "getSchema",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/dynamicfields.schema",
			name: "getDynamicSchema",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/fields/{field}",
			name: "deleteField",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "field",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/dynamicfields/{field}",
			name: "deleteDynamicField",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "field",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/collections/{collection}/schema/fields/{fieldName}",
			name: "updateField",
			verb: "PUT",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "fieldName",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}/schema/dynamicfields/{fieldName}",
			name: "updateDynamicField",
			verb: "PUT",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "fieldName",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/collections/{collection}/schema/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"session::v1": {
	name: "com.lucidworks.apollo.resources.session",
	uri: "/session",
	methods: [
		{
			uri: "/session",
			name: "getSession",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"solr::v1": {
	name: "com.lucidworks.apollo.resources.SolrProxyResource",
	uri: "/solr",
	methods: [
		{
			uri: "/solr",
			name: "ok",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/solr/{collection}/{path:.*}",
			name: "proxyRequestToSolr",
			verb: "GET",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/solr/{collection}/{path:.*}",
			name: "proxyPostRequestToSolr",
			verb: "POST",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/solr/{collection}/{path:.*}",
			name: "proxyPutRequestToSolr",
			verb: "PUT",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/solr/{collection}/{path:.*}",
			name: "proxyDeleteRequestToSolr",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "path",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/solr/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"spark::v1": {
	name: "com.lucidworks.apollo.resources.SparkResource",
	uri: "/spark",
	methods: [
		{
			uri: "/spark/configurations/{id}",
			name: "deleteConfiguration",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/configurations/{id}",
			name: "updateConfiguration",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/spark/configurations/{id}",
			name: "getConfiguration",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs/{id}",
			name: "startJob",
			verb: "POST",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "sync",
					type: "Boolean"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs/{id}",
			name: "getJobStatus",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs/{id}",
			name: "stopJob",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/info",
			name: "getHealthStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/driver/default",
			name: "getLogsFromDefaultDriver",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "jobId",
					type: "String"
				},
				{
					name: "jobRunId",
					type: "String"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/driver/scripted",
			name: "getLogsFromScriptedDriver",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "jobId",
					type: "String"
				},
				{
					name: "jobRunId",
					type: "String"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/driver/launcher",
			name: "getLogsFromLauncherDriver",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "jobId",
					type: "String"
				},
				{
					name: "jobRunId",
					type: "String"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/api",
			name: "getLogsFromApi",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "jobId",
					type: "String"
				},
				{
					name: "jobRunId",
					type: "String"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/sql",
			name: "getLogsFromSql",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/master",
			name: "getLogsFromSparkMaster",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/worker",
			name: "getLogsFromSparkWorker",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "rows",
					type: "int"
				},
				{
					name: "pattern",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/log/job/{jobId}",
			name: "getLogsForJob",
			verb: "GET",
			pathParams: [
				{
					name: "jobId",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "jobRunId",
					type: "String"
				},
				{
					name: "rows",
					type: "int"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/driver",
			name: "stopSparkContext",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/jar",
			name: "getUberjar",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/master",
			name: "getMaster",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/master/status",
			name: "getAllMasterStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/master/config",
			name: "getMasters",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/worker/config",
			name: "getWorkers",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/driver/status",
			name: "getDrivers",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/schema",
			name: "getConfigurationTypes",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs",
			name: "stopAllJobs",
			verb: "DELETE",
			pathParams: [
			],
			queryParams: [
				{
					name: "type",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs",
			name: "listAllJobs",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
				{
					name: "type",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/jobs",
			name: "startUndefinedJob",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "sync",
					type: "Boolean"
				}
			],
			hasEntity: true
		},
		{
			uri: "/spark/jobs/{id}/{key}",
			name: "getDataFromStatus",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				},
				{
					name: "key",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/script",
			name: "startUndefinedScriptedJob",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
				{
					name: "sync",
					type: "Boolean"
				},
				{
					name: "rows",
					type: "Integer"
				}
			],
			hasEntity: true
		},
		{
			uri: "/spark/configurations",
			name: "listConfigurations",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/spark/configurations",
			name: "createConfiguration",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/spark/jobs/{collection}/{id}/output",
			name: "deleteJobOutput",
			verb: "DELETE",
			pathParams: [
				{
					name: "collection",
					type: "String"
				},
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
				{
					name: "jobId",
					type: "String"
				}
			],
			hasEntity: false
		},
		{
			uri: "/spark/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"tasks::v1": {
	name: "com.lucidworks.apollo.resources.TaskResource",
	uri: "/tasks",
	methods: [
		{
			uri: "/tasks",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/tasks",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/tasks/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/tasks/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/tasks/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/tasks/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/tasks/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
},
	"data-models::v1": {
	name: "com.lucidworks.apollo.resources.DataModelResource",
	uri: "/data-models",
	methods: [
		{
			uri: "/data-models",
			name: "createEntity",
			verb: "POST",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/data-models",
			name: "getAllEntities",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/data-models/_schema",
			name: "getEntitySchema",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/data-models/{id}/fields",
			name: "getDataModelFields",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/data-models/_backcompat/{id}",
			name: "deleteEntity",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/data-models/{id}",
			name: "getEntity",
			verb: "GET",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: false
		},
		{
			uri: "/data-models/{id}",
			name: "updateEntity",
			verb: "PUT",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/data-models/{id}",
			name: "deleteEntityWithBody",
			verb: "DELETE",
			pathParams: [
				{
					name: "id",
					type: "String"
				}
			],
			queryParams: [
			],
			hasEntity: true
		},
		{
			uri: "/data-models/status",
			name: "getStatus",
			verb: "GET",
			pathParams: [
			],
			queryParams: [
			],
			hasEntity: false
		}
	]
}
};

const globalServices = [
    'apps',
    'license',
    'configurations',
    'dynamicSchema',
    'features',
    'history',
    'indexPipelineTemplates',
    'introspect',
    'links',
    'messaging',
    'nodes',
    'objects',
    'parserTemplates',
    'partitions',
    'queryPipelineTemplates',
    'registration',
    'schedulers',
    'schema',
    'searchCluster',
    'searchLogs',
    'session',
    'solr',
    'solrAdmin',
    'solrconfig',
    'stopwords',
    'synonyms',
    'synonymsEditor',
    'system',
    'systemAutocomplete',
    'taxonomy',
    'usage',
    'zkImportExport',
];
const globalMethods = [
    'dropDb',
    'getConfigurationTypes',
    'getEntitySchema',
    'listFeatures',
    'listResources',
    'listStageInstances',
    'listStageSchemas',
    'overwriteFeature',
    'proxyPostRequestToSolr',
];
const appSpecificMethodsByServiceName = {
    connectors: [
        'getItem',
        'deleteItem',
        'getDataSources',
        'removeDataSources',
        'addDataSource',
        'removeDataSource',
        'getDataSource',
        'updateDataSource',
    ],
};

class FusionApiService extends ApiService {
    constructor(config) {
        const defaultConfig = {
            apiMeta: IntrospectApiData,
            extractUrlAppIdRegexp: /^.*\/apps\/(.*?)(\/|$)/,
        };
        super(lodash.merge(defaultConfig, config));
    }
    /**
     * Override request config typing.
     * @override
     */
    invoke(serviceName, serviceMethod, config = {}) {
        return super.invoke(serviceName, serviceMethod, config);
    }
    /**
     * Get App ID from URL params.
     */
    getAppId() {
        const config = this.config;
        const matches = window.location.pathname.match(config.extractUrlAppIdRegexp) || [];
        return matches[1];
    }
    /**
     * Override service config typing.
     * @override
     */
    setConfig(config, overwrite = false) {
        super.setConfig(config, overwrite);
    }
    redirectToLoginPage() {
        const currentUrl = window.location.toString();
        const fusionLoginUrl = `${this.serviceHost}/auth/login`;
        window.location.replace(`${fusionLoginUrl}?return=${encodeURIComponent(decodeURI(currentUrl))}`);
    }
    /**
     * Provide common query params, such as app ID info { context: app:my-app }
     * @override
     */
    getBasePath(config = {}, serviceName, methodName) {
        const appId = config.appId || this.getAppId();
        const defaultBasePath = super.getBasePath(config, serviceName, methodName);
        let customBasePath;
        // TODO: Support customization on global service/methods handling.
        if (appId) {
            const appSpecificMethods = lodash.get(appSpecificMethodsByServiceName, serviceName);
            let isAppSpecific;
            if (!lodash.isEmpty(appSpecificMethods)) {
                isAppSpecific = lodash.includes(appSpecificMethods, methodName);
            }
            if (!isAppSpecific) {
                isAppSpecific = !config.crossApp && !lodash.includes(globalServices, serviceName) && !lodash.includes(globalMethods, methodName);
            }
            if (isAppSpecific) {
                customBasePath = `${defaultBasePath}/apps/${appId}`;
            }
        }
        return customBasePath || defaultBasePath;
    }
    /**
     * Check the authentication state.
     */
    checkAuthStateOnError(error) {
        const authorized = (error.status !== 401);
        if (!authorized) {
            this.redirectToLoginPage();
        }
        return authorized;
    }
}

const apiParams = {
    crossApp: false,
    service: 'data-models',
};
class DataModelsStore extends FusionDataStore {
    constructor() {
        var _a, _b;
        const apiService = new FusionApiService();
        super({ apiMeta: (_b = (_a = apiService.meta) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.apiMeta });
    }
    getDataModelFields(modelId) {
        const config = Object.assign({ name: 'getDataModelFields' }, apiParams);
        return this.callApiMethod(config, {}, { pathParams: { id: modelId } });
    }
    getSchema() {
        const config = Object.assign({ name: 'getEntitySchema' }, apiParams);
        return this.callApiMethod(config, {}, {});
    }
}
DataModelsStore.defaultConfig = {
    crossApp: apiParams.crossApp,
    api: {
        service: 'data-models',
        list: 'getAllEntities',
        get: 'getEntity',
        add: 'createEntity',
        update: 'updateEntity',
        remove: 'deleteEntity',
        includeItemDetailsInList: true,
    },
};

class FusionSearchResultStore extends FusionDataStore {
    constructor(config) {
        super(config);
        this.activeFacets = [];
        this.defaultQueryParams = {};
        this.focusDocs = [];
        this.groupCountProp = '_group_item_count_';
        this.fetchGroupContentQueryParam = 'fetch_group_content_';
        this.paginationParamList = ['start', 'rows', 'numFound'];
        this.searchParamList = ['q', 'sortAsc', 'sortBy', ...this.paginationParamList];
        this.defaultQuery = '*:*';
        this.transformFacetFields = (meta, title) => {
            let facets;
            if (lodash.isArray(meta)) {
                facets = lodash(meta)
                    .chunk(2)
                    .map(([value, count]) => ({ title, value: String(value), count: Number(count) }))
                    .reject({ count: 0 })
                    .value();
            }
            else {
                facets = lodash.map(meta, (count, fieldName) => ({ title, count, value: fieldName }));
            }
            return { title, facets };
        };
        this.transformFacetRanges = (meta, title) => {
            const other = lodash(meta).pick(['after', 'before', 'between']).omitBy((val) => val === 0).value();
            const facets = lodash(meta.counts)
                .chunk(2)
                .map(([value, count], index, array) => ({
                title,
                value: `${value} - ${lodash.get(array, `[${index + 1}][0]`, meta.end)}`,
                count: Number(count)
            }))
                .reject({ count: 0 })
                .value();
            return { title, facets, other };
        };
        this.alwaysRefreshData = true;
        this.defaultParamsList = [...this.defaultParamsList, 'search'];
        this.defaultQueryParams = this.config.api.search.queryParams;
        this.resetSearchQueryParams();
        lodash.defaults(this.apiConfig.search, { transform: lodash.bind(this.transFormSearchResult, this) });
    }
    /**
     * == Public methods =============================================================================
     */
    /**
     * Append search related info to meta.
     * The `meta` getter is hooked up with it in the super class, which provides the read-only info via store.meta.
     */
    getMeta() {
        const props = this.cloneProps(['searchParams', 'activeFacets', 'focusDocs']);
        const grouping = {
            mode: this.groupMode,
            field: this.groupBy,
            countProp: this.groupCountProp,
        };
        lodash.merge(props, {
            searchParams: {
                numFound: this.searchParams.numFound,
                fqs: lodash.get(this.getLoadConfig(), 'queryParams.fq'),
            }
        });
        return Object.assign(Object.assign(Object.assign({}, super.getMeta()), { grouping }), props);
    }
    filter(q) {
        const isChanged = (q !== this.searchParams.q) && !(lodash.isEmpty(q) && (this.searchParams.q === this.defaultQuery));
        if (isChanged) {
            this.setSearchTerm(q);
            this.searchParams.start = 0;
        }
        return this.getResultList(isChanged);
    }
    setPage(page = 1) {
        this.searchParams.start = this.searchParams.rows * (page - 1);
        return this.load();
    }
    setPageByMeta({ start, rows }) {
        this.searchParams.rows = rows;
        return this.setPage(Math.ceil(start / rows) + 1);
    }
    selectFacet(selectedFacet) {
        const { field, value } = selectedFacet;
        const meta = { fieldName: field };
        if (value) {
            meta.fieldValue = value;
        }
        const existingFacet = lodash.find(this.activeFacets, meta);
        if (!selectedFacet.multi) {
            this.activeFacets = lodash.reject(this.activeFacets, { fieldName: selectedFacet.field });
        }
        this.activeFacets = existingFacet
            ? lodash.reject(this.activeFacets, meta)
            : [...this.activeFacets, Object.assign(Object.assign({}, meta), lodash.pick(selectedFacet, ['type', 'multi']))];
        this.searchParams.start = 0;
        return this.load();
    }
    setFacets(facets) {
        const propMap = { title: 'fieldName', value: 'fieldValue' };
        const updatedFacets = facets.map((facet) => lodash.mapKeys(facet, (_value, key) => propMap[key] || key));
        const isChanged = !lodash.isEqual(this.activeFacets, updatedFacets);
        if (isChanged) {
            this.activeFacets = updatedFacets;
        }
        return this.getResultList(isChanged);
    }
    setFacetsFromFqs(fqs) {
        const facets = lodash([fqs])
            .flatten()
            .map(this.getFacetFromFq)
            .flatten()
            .compact()
            .value();
        const hasFacets = !lodash.isEmpty(facets);
        if (hasFacets) {
            this.activeFacets.push(...facets);
        }
        return this.getResultList(hasFacets);
    }
    sort(prop, asc = true) {
        this.searchParams.sortBy = prop;
        this.searchParams.sortAsc = asc;
        return this.load();
    }
    clearFilterAndFacets() {
        this.activeFacets = [];
        this.setSearchTerm(this.defaultQuery);
        return this.load();
    }
    searchOnDocs(matches) {
        this.focusDocs = [...matches];
        return this.clearFilterAndFacets();
    }
    /**
     * @override
     */
    clear(reload = true, clearQueryParams = false) {
        if (clearQueryParams) {
            this.activeFacets = [];
            this.focusDocs = [];
            this.resetSearchQueryParams();
            this.clearGroupMode();
        }
        super.clear(reload);
    }
    /**
     * == Protected and private methods ==============================================================
     */
    /**
     * @override
     */
    getLoadConfig() {
        const apiConfig = lodash.cloneDeep(this.apiConfig.search);
        const defaultFq = lodash.get(apiConfig.queryParams, 'defaultFq');
        apiConfig.queryParams = Object.assign(Object.assign({}, apiConfig.queryParams), this.searchParams);
        if (lodash.isEmpty(this.activeFacets)) {
            delete apiConfig.queryParams.fq;
        }
        else {
            this.addFq(apiConfig, this.getFacetsFq(this.activeFacets));
        }
        if (defaultFq) {
            this.addFq(apiConfig, defaultFq);
        }
        if (!lodash.isEmpty(this.focusDocs)) {
            const list = this.focusDocs.map(({ field, value }) => `(${field}:"${value}")`);
            const docsFq = `${list.join(' OR ')}`;
            this.addFq(apiConfig, docsFq);
        }
        if (this.groupMode) {
            const isCollapseExpand = (this.groupMode === 'collapse-expand');
            lodash.assign(apiConfig.queryParams, Object.assign(Object.assign({}, !isCollapseExpand && { 'group.ngroups': true }), isCollapseExpand && { expand: true, 'expand.rows': 1 }));
        }
        if (lodash.isFunction(apiConfig.processQueryParams)) {
            apiConfig.processQueryParams(apiConfig, this.searchParams);
        }
        if (apiConfig.queryParams.fq) {
            apiConfig.queryParams.fq = apiConfig.queryParams.fq.map((fq) => encodeURIComponent(fq));
        }
        return apiConfig;
    }
    /**
     * @override
     */
    getNotificationPayload() {
        return Object.assign(Object.assign({}, super.getNotificationPayload()), { activeFacets: this.activeFacets, paginationMeta: lodash.pick(this.searchParams, this.paginationParamList) });
    }
    resetSearchQueryParams() {
        this.searchParams = lodash.pick(this.defaultQueryParams, this.searchParamList);
        this.setSearchTerm();
    }
    transFormSearchResult(data) {
        const facets = data.facet_counts || {};
        const { numFound, docs } = this.getResultsMeta(data);
        const { facet_fields: facetFields, facet_ranges: facetRanges } = facets;
        const existingFacets = [...lodash.keys(facetFields), ...lodash.keys(facetRanges)];
        // Filters out invalid facets.
        const filteredFacets = lodash.filter(this.activeFacets, (facet) => lodash.includes(existingFacets, facet.fieldName));
        if (!lodash.isEqual(this.activeFacets, filteredFacets)) {
            this.activeFacets = filteredFacets;
            // reload after a facet has been manually cleared from the store
            this.load();
        }
        setInnumerableProp(this.searchParams, 'numFound', numFound);
        return {
            docs,
            facets: {
                fields: lodash.map(facetFields, this.transformFacetFields),
                ranges: lodash.map(facetRanges, this.transformFacetRanges),
            },
        };
    }
    checkGroupMode(data) {
        if (this.groupMode || !this.getLoadConfig().supportResultGrouping) {
            return;
        }
        const params = lodash.get(data, 'responseHeader.params', {});
        if (params.group === 'true') {
            this.groupMode = lodash.get(params, 'group.format') === 'simple' ? 'simple-result-grouping' : 'result-grouping';
            this.groupBy = lodash.get(params, 'group.field');
        }
        else {
            const fqList = lodash.flatten([params.fq]);
            const collapseFq = lodash.find(fqList, (fq) => lodash.includes(fq, 'collapse'));
            if (collapseFq) {
                this.groupMode = 'collapse-expand';
                this.groupBy = lodash.get(collapseFq.match(/field=([^\s}]*)/), '[1]');
                if (lodash.startsWith(this.groupBy, `"`) && lodash.endsWith(this.groupBy, `"`)) {
                    this.groupBy = lodash.trim(this.groupBy, `"`);
                }
            }
        }
    }
    getResultsMeta(data, params = {}) {
        const fetchingGroupContent = lodash.get(params, this.fetchGroupContentQueryParam);
        let numFound;
        let docs;
        let groupExpandMeta;
        this.checkGroupMode(data);
        if (lodash.includes(this.groupMode, 'result-grouping')) {
            const groupsData = data.grouped;
            const groupedMeta = groupsData[Object.keys(groupsData)[0]];
            if (this.groupMode === 'simple-result-grouping') {
                docs = lodash.get(groupedMeta, 'doclist.docs');
            }
            else if (!lodash.isUndefined(fetchingGroupContent)) {
                // Ideally `groupedMeta.groups[0]` will be the expected entry as all other groups should be
                // filtered out by fq (groupField: groupValue). However, the fq will be ignored in some cases.
                // For example, when having bury rules at the group level, or when the group is pinned.
                // Do extra search by the group value to make sure it's targeting the expected group content list.
                const groupValue = lodash.isNumber(fetchingGroupContent) ? fetchingGroupContent : fetchingGroupContent || undefined;
                const group = lodash.find(groupedMeta.groups, (item) => item.groupValue === groupValue);
                docs = lodash.get(group, 'doclist.docs');
            }
            else {
                const groups = lodash.get(groupedMeta, 'groups');
                docs = lodash.map(groups, 'doclist.docs[0]');
            }
            // FIXME: Simple mode doesn't always get ngroups, add fallback for it when necessary.
            numFound = lodash.get(groupedMeta, 'ngroups', docs.length);
            groupExpandMeta = lodash(groupedMeta.groups).keyBy('groupValue').mapValues('doclist').value();
        }
        else {
            const isCollapseExpand = (this.groupMode === 'collapse-expand');
            const fetchingExpandContent = fetchingGroupContent && isCollapseExpand;
            let docProp;
            numFound = lodash.get(data, 'response.numFound');
            groupExpandMeta = data.expanded;
            docProp = fetchingExpandContent ? groupExpandMeta[Object.keys(groupExpandMeta)[0]] : data.response;
            docs = lodash.get(docProp, 'docs');
            if (isCollapseExpand && !lodash.isEmpty(groupExpandMeta) && !fetchingExpandContent) {
                docs = docs.map((doc) => lodash.get(groupExpandMeta, `${doc[this.groupBy]}.docs[0]`, doc));
            }
        }
        if (groupExpandMeta) {
            const field = lodash.get(this.meta, 'grouping.field');
            lodash.each(docs, (doc) => {
                const count = lodash.get(groupExpandMeta, `${doc[field]}.numFound`);
                if (count) {
                    doc[this.groupCountProp] = count;
                }
            });
        }
        return { docs, numFound };
    }
    getFacetsFq(facets) {
        return lodash(facets)
            .groupBy('fieldName')
            .mapValues(group => (Object.assign(Object.assign({}, group[0]), { fieldValue: lodash.map(group, 'fieldValue') })))
            .map((facetGroup) => this.getFacetFq(facetGroup))
            .value();
    }
    addFlagToRequestGroupContentParam(params, groupValue) {
        setInnumerableProp(params, this.fetchGroupContentQueryParam, groupValue);
    }
    clearGroupMode() {
        this.groupMode = undefined;
        this.groupBy = undefined;
    }
    /**
     *
     * @param {any} fieldName field name
     * @param {any[]} fieldValue an array of selected field values
     * @param {any} type facet type e.g. range or field
     * @param {any} multi whether the select type is multi or not (single)
     * @returns {string}
     */
    getFacetFq({ fieldName, fieldValue, type = 'field', multi = false }) {
        const value = fieldValue.map(val => this.getFacetFqValue(val, type)).join(' OR ');
        const tag = multi ? `{!tag=${fieldName}}` : '';
        return `${tag}${fieldName}:(${value})`;
    }
    getFacetFqValue(fieldValue, type = 'field') {
        if (type === 'range') {
            fieldValue = fieldValue.replace(' - ', ' TO ');
        }
        return type === 'range' ? `[${fieldValue}}` : `"${fieldValue}"`;
    }
    setSearchTerm(q = this.searchParams.q) {
        this.searchParams.q = q || this.defaultQuery;
    }
    addFq(config, fq) {
        config.queryParams.fq = [...lodash.flatten([fq]), ...(config.queryParams.fq || [])];
    }
    getResultList(reload = false) {
        return reload ? this.load() : Promise.resolve(this.getNotificationPayload());
    }
    // REVIEW: Generalize this handling as well as reducing exit points a bit in the next round.
    getFacetFromFq(fq) {
        fq = decodeURIComponent(fq);
        // Match multi-select field or range
        let matches = /\{!tag=[^}]*\}([^:]+):\(\"?([^)]+)\"?\)/.exec(fq);
        if (matches) {
            const fieldName = matches[1];
            const values = matches[2].replace(/"/g, '').split(' OR ');
            return values.map(value => {
                const rangeMatches = /\[([^)]+)\s(TO)\s([^)]+)\}/.exec(value);
                let type = 'field';
                if (rangeMatches) {
                    type = 'range';
                    value = `${rangeMatches[1]} - ${rangeMatches[3]}`;
                }
                return {
                    multi: true,
                    fieldName,
                    type,
                    fieldValue: value
                };
            });
        }
        // Match single select range facets
        matches = /:\(\[([^)]+)\s(TO)\s([^)]+)\}\)/.exec(fq);
        if (matches) {
            return {
                fieldName: fq.replace(matches[0], ''),
                fieldValue: `${matches[1]} - ${matches[3]}`,
                type: 'range'
            };
        }
        // Match single-select
        matches = /:\(\"([^)]+)\"\)/.exec(fq);
        if (matches) {
            return {
                fieldName: fq.replace(matches[0], ''),
                fieldValue: matches[1],
            };
        }
        return null;
    }
}

class QueryProfilesStore extends FusionDataStore {
}
QueryProfilesStore.defaultConfig = {
    api: {
        service: 'queryProfilesCrud',
        list: 'getAllEntities',
        get: 'getEntity',
    },
};

class RulesStore extends FusionSearchResultStore {
    publish() {
        return this.callApiMethod({ name: 'publishAll', refreshAfter: true });
    }
    publishRule(id) {
        return this.callApiMethod({ name: 'publishRule', refreshAfter: true }, {}, { pathParams: { id } });
    }
    undo() {
        return this.callApiMethod({ name: 'rollbackAll', refreshAfter: true });
    }
    rollbackRule(id) {
        return this.callApiMethod({ name: 'rollback', refreshAfter: true }, {}, { pathParams: { id } });
    }
    doBulkOperation(options, params) {
        return this.callApiMethod({ name: 'doBulkOperation', refreshAfter: true }, options, params);
    }
    searchRelatedRules(id) {
        return this.callApiMethod({ name: 'getRelatedRules' }, {}, { queryParams: { docId: id } });
    }
    searchAll(options, params = {}) {
        const config = {
            name: 'searchAll',
            queryParams: {
                q: '*:*',
                isDeleted: true,
            },
        };
        return this.callApiMethod(config, options, params);
    }
    /* Search rules by params such as { queryParams: { q: $searchTerm, fq: 'field: "value"' } } */
    searchRules(params = {}) {
        let fq = lodash.get(params, 'queryParams.fq');
        fq = fq ? lodash.flatten([fq]) : [];
        params.queryParams.fq = [...fq, RulesStore.defaultFq];
        return this.searchAll({}, params)
            .then(({ response }) => ({
            rules: lodash.get(response, 'docs'),
            count: lodash.get(response, 'numFound'),
        }));
    }
    getUnPublishedRules(params) {
        const queryParams = Object.assign({ fq: ['deployed:"false"', '-review:pending'], rows: RulesStore.UNPUBLISHED_RULES_PER_PAGE, sort: 'createdOn+desc' }, params);
        return this.searchRules({ queryParams })
            .then(({ rules, count: numUnpublished }) => ({ rules, numUnpublished }));
    }
    setType(type) {
        this.clear();
        this.setApiConfig({
            prop: 'pathParams',
            value: { type },
        });
    }
    async getSchemaByType(type) {
        let schema = RulesStore.rulesSchemaMap[type];
        if (!schema) {
            schema = await this.callApiMethod({ name: 'getSchema' }, {}, { pathParams: { type } });
            RulesStore.rulesSchemaMap[type] = schema;
        }
        return Promise.resolve(schema);
    }
}
RulesStore.UNPUBLISHED_RULES_PER_PAGE = 20;
RulesStore.defaultFq = '(doc_type:("rule") OR (type:("spell" OR "phrase" OR "tail")) OR (type:"synonym" AND -synid_s:* AND mappings:*) OR (type:"removeWords" AND -removeid_s:* AND trigger_phrase_ss:*))';
RulesStore.rulesSchemaMap = {};
RulesStore.defaultConfig = {
    api: {
        service: 'queryRewrite',
        search: {
            name: 'searchAll',
            queryParams: {
                q: '*:*',
                rows: 0,
                start: 0,
                sortAsc: false,
                sortBy: 'createdOn',
                fl: '*',
                isDeleted: true,
                defaultFq: RulesStore.defaultFq,
                // Facets params:
                'facet.field': ['type', 'enabled', 'deployed'],
                'facet.mincount': 1,
            },
            processQueryParams: (config, searchParams) => {
                config.queryParams = lodash.omit(Object.assign(Object.assign({}, config.queryParams), { sort: `${searchParams.sortBy}+${searchParams.sortAsc ? 'asc' : 'desc'}` }), 'sortBy', 'sortAsc');
            },
        },
        get: 'getQueryRewrite',
        add: 'create',
        update: 'updateQueryRewrite',
        remove: 'deleteQueryRewrite',
    },
};

class SolrStore extends FusionDataStore {
    proxyRequestToSolr(options, params) {
        return this.callAdvancedMethod('proxyRequestToSolr', options, params);
    }
    proxyPostRequestToSolr(options, params) {
        return this.callAdvancedMethod('proxyPostRequestToSolr', options, params);
    }
    callAdvancedMethod(method, options, params) {
        return this.callApiMethod({ name: method }, options, params);
    }
}
SolrStore.defaultConfig = {
    crossApp: true,
    api: {
        service: 'solr',
    },
};

class BlobsStore extends FusionDataStore {
}
BlobsStore.defaultConfig = {
    api: {
        service: 'blobs',
        list: 'listBlobManifests',
        get: 'getBlob',
        remove: 'deleteFile',
        add: {
            name: 'putBlob',
            headers: { 'Content-Type': '${itemData.type}' },
            pathParams: { id: '${itemData.name}' },
            queryParams: { resourceType: '${resourceType}' },
        },
        update: {
            name: 'putBlob',
            headers: { 'Content-Type': '${itemData.type}' },
            pathParams: { id: '${itemData.name}' },
            queryParams: { resourceType: '${resourceType}' },
        },
    },
};

class SessionStore extends FusionDataStore {
    getSession() {
        const config = {
            name: 'getSession',
        };
        return this.callApiMethod(config, {});
    }
}
SessionStore.defaultConfig = {
    api: {
        service: 'session',
    },
};

const sortFusionFields = (fields, fieldProp) => {
    return lodash.sortBy(fields, (field) => {
        const name = field[fieldProp] || field;
        return [lodash.startsWith(name, '_'), name];
    });
};

const fusionUtils = /*#__PURE__*/Object.freeze({
    __proto__: null,
    sortFusionFields: sortFusionFields
});

export { AnalyticsEventType, AppsStore, authUtils as AuthUtils, BlobsStore, DataModelsStore, EventService, FusionApiService, FusionDataStore, FusionSearchResultStore, fusionUtils as FusionUtils, MoDataStore, QueryProfilesStore, RulesStore, SessionStore, SolrStore, storybookUtils as StorybookUtils, index$1 as TemplatingHelpers, index as TemplatingInterfaces, analytics, appSpecificMethodsByServiceName, featureFlagService, getAnalyticsService, globalMethods, globalServices, setupAnalyticsWorkflow };
